import ls from 'local-storage';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { combineReducers } from 'redux';
import 'react-dom/server';
import ReactMarkdown from 'react-markdown';
import { NavigationContext } from 'alpha-page';
import moment from 'moment';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import '@material-ui/core/Drawer';
import Fab from '@material-ui/core/Fab';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBackIos';
import '@material-ui/icons/HighlightOff';
import 'react-reveal/Slide';
import 'react-reveal/Fade';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Reveal from 'react-reveal/Zoom';
import Card from '@material-ui/core/Card';
import '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent$1 from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActions';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import SlickSlider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import SendIcon from '@material-ui/icons/Send';
import '@material-ui/icons/Cancel';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';
import '@material-ui/core/Popover';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Slide$2 from '@material-ui/core/Slide';
import ForumIcon from '@material-ui/icons/Forum';
import CloseIcon from '@material-ui/icons/Close';

function updateObject(oldObject, newValues) {
  return Object.assign({}, oldObject, newValues);
}
function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) return handlers[action.type](state, action);else if (handlers.hasOwnProperty("*")) return handlers["*"](state, action);else return state;
  };
}

const visitorInitial = {
  isInitialized: false,
  isInitializing: false,
  isRegistered: false,
  isRegistering: false,
  data: {
    _goid: null,
    visitor_id: null
  }
}; // Actions

const ACTION = {
  initializing: "initializing",
  registering: "registering",
  receiveInitResult: "receiveInitResult",
  receiveRegisterResult: "receiveRegisterResult",
  errorInitializing: "errorInitializing",
  errorRegistering: "errorRegistering"
}; // Async Action Creators

const getVisitor = state => {
  if ('visitor' in state.alpha) return state.alpha.visitor;else return visitorInitial;
};
const init = () => {
  return (dispatch, getState) => {
    let visitor = getVisitor(getState());
    if (visitor.isInitialized || visitor.isInitializing) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + '/visitor/api/init/';
    let data = {
      _goid: visitor.data._goid,
      _referer: document.referrer,
      _origin: window.location.href
    }; //  alert("init: " + JSON.stringify(data))
    //  alert(process.env.REACT_APP_GOAPP_API_KEY)
    //    alert("Fetching: " + url)

    dispatch(initializing());
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => dispatch(receiveInitResult(json))).catch(error => dispatch(errorInitializing(error)));
  };
};
const register = registerData => {
  return (dispatch, getState) => {
    let visitor = getVisitor(getState());
    if (visitor.isRegistered || visitor.isRegistering) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + '/visitor/api/register_user/';
    let data = { ...registerData,
      _goid: visitor.data._goid
    };
    dispatch(registering());
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => dispatch(receiveRegisterResult(data, json))).catch(error => dispatch(errorRegistering(registerData, error)));
  };
};
const logEvent = (eventName, eventData) => {
  return (dispatch, getState) => {
    let visitor = getVisitor(getState());
    if (!visitor.isRegistered) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + '/visitor/api/log_event/';
    let data = {
      event_name: eventName,
      event_data: eventData,
      _goid: visitor.data._goid
    }; //    alert("LogEvent: " + JSON.stringify(data, null, 2))

    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => {//      alert("result: " + JSON.stringify(json))
      //      ls.set('_goid', json['_goid'])
      //      cookie.set("onboarded", true, {path: "/"});
    }).catch(error => {});
  };
}; // Synchronous Action Creators

const initializing = () => ({
  type: ACTION.initializing
});
const registering = registerData => ({
  type: ACTION.registering
});
const receiveInitResult = json => ({
  type: ACTION.receiveInitResult,
  result: json
});
const receiveRegisterResult = (registerData, json) => ({
  type: ACTION.receiveRegisterResult,
  registerData,
  result: json
});
const errorInitializing = error => ({
  type: ACTION.errorInitializing,
  error
});
const errorRegistering = (data, error) => ({
  type: ACTION.errorRegistering,
  data,
  error
}); // Visitor reducer

function _initializing(state, action) {
  return { ...state,
    isInitializing: true
  };
}

function _registering(state, action) {
  return { ...state,
    isRegistering: true
  };
}

function _errorInitializing(state, action) {
  alert(action.error);
  return { ...state,
    isInitializing: false
  };
}

function _errorRegistering(state, action) {
  alert(action.error);
  return { ...state,
    isRegistering: false
  };
}

function _receiveInitResult(state, action) {
  let _goid = action.result['_goid']; // Store _goid on local storage

  ls.set('_goid', _goid);
  return { ...state,
    isInitializing: false,
    isInitialized: true,
    data: {
      _goid: _goid
    }
  };
}

function _receiveRegisterResult(state, action) {
  return { ...state,
    isRegistering: false,
    isRegistered: true,
    data: { ...state.data,
      ...action.result
    }
  };
}

const visitorReducer = (state = null, action) => {
  if (state == null) {
    // Get userInitial from local storage, but we're still in
    // not authenticated state, authToken is still null.
    // We'll use the info to auto authenticate to auth service
    state = visitorInitial;

    let _goid = ls.get('_goid');

    if (_goid && _goid !== undefined && _goid != "undefined") state.data._goid = _goid;
  }

  const handlers = {
    [ACTION.initializing]: _initializing,
    [ACTION.registering]: _registering,
    [ACTION.receiveInitResult]: _receiveInitResult,
    [ACTION.receiveRegisterResult]: _receiveRegisterResult,
    [ACTION.errorInitializing]: _errorInitializing,
    [ACTION.errorRegistering]: _errorRegistering
  };
  if (handlers.hasOwnProperty(action.type)) return handlers[action.type](state, action);else return state;
};

const userInitial = {
  isAuthenticating: false,
  isLoggedIn: false,
  authToken: null,
  userInfo: null,
  isUpdatingContact: false,
  lastContactUpdate: null,
  contactInfo: null,
  companyInfo: null
}; // Actions

const ACTION$1 = {
  authenticateWithToken: "authenticateWithToken",
  completeLogout: "completeLogout",
  authenticating: "authenticating",
  receiveTokenInfo: "receiveAuthInfo",
  errorAuthenticating: "errorAuthenticating",
  updatingContact: "updatingContact",
  receiveContactInfo: "receiveContactInfo",
  errorUpdatingContact: "errorUpdatingContact",
  activateCompany: "activateCompany"
};
const getUser = state => {
  return state.alpha.user;
};
const getCompanies = state => {
  let user = getUser(state);
  if (!user.isLoggedIn || !user.contactInfo) return [];
  if ('companies' in user.contactInfo) return user.contactInfo.companies;else return [];
}; // Async Action Creators

const login = (callbackUrl, removeUserInfo = false, register = false) => {
  return (dispatch, getState) => {
    let user = getState().alpha.user;
    if (user.isLoggedIn || user.isAuthenticating) return Promise.resolve(); // Open login page

    let url = process.env.REACT_APP_ACCOUNT_URL + "/account/authorize/";
    let params = {
      callback: callbackUrl,
      business: getState().alpha.business[0].data.uid
    }; // Try to login with previous identity

    if (user.userInfo && 'uid' in user.userInfo) {
      params['uid'] = user.userInfo.uid;
      if (removeUserInfo) // Remove userInfo from local storage, so that we don't try to login
        // if failed
        ls.remove('_userInfo');
    } // 12 Dec 2019. Add visitor info so that we can link new user to this contact


    let visitor = getVisitor(getState());
    if (visitor && visitor.data.visitor_id) params['visitor'] = visitor.data.visitor_id;
    if (register) params['register'] = 1; //    alert(JSON.stringify(params, null, 2))
    //    let params = { callback: process.env.REACT_APP_PUBLIC_URL + "/auth_callback" }
    //    let params = { callback: "http://178.128.86.10:9000/auth_callback/" }

    url = url + "?" + Object.entries(params).map(kv => kv.map(encodeURIComponent).join("=")).join("&"); // Redirect to url

    window.open(url, '_self');
  };
};
const register$1 = (callbackUrl, removeUserInfo = false) => {
  return login(callbackUrl, removeUserInfo, true);
};
const logout = callbackUrl => {
  return (dispatch, getState) => {
    let user = getState().alpha.user;
    if (!user.isLoggedIn) return Promise.resolve(); // Remove _userInfo to prevent auto login

    ls.remove('_userInfo'); // Logout from authentication service.

    let url = process.env.REACT_APP_ACCOUNT_URL + "/account/logout/";
    let params = {
      callback: callbackUrl,
      business: getState().alpha.business[0].data.uid
    };
    url = url + "?" + Object.entries(params).map(kv => kv.map(encodeURIComponent).join("=")).join("&"); // Redirect to url

    window.open(url, '_self'); //    // Reset user to initial
    //    dispatch(completeLogout())
  };
};
const authenticateWithToken = authToken => {
  return (dispatch, getState) => {
    let user = getState().alpha.user;
    if (user.isAuthenticating) return Promise.resolve();
    let url = process.env.REACT_APP_ACCOUNT_URL + "/auth/token-info/";
    let data = {
      token: authToken
    }; //    alert(url)

    dispatch(authenticating());
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => response.json()).then(json => {
      dispatch(receiveTokenInfo(authToken, json)); //        dispatch(fetchCart(authToken))
    }).catch(error => dispatch(errorAuthenticating(error)));
  };
};
const setActiveCompany = companyID => {
  return (dispatch, getState) => {
    let user = getState().alpha.user;
    if (!user.isLoggedIn || !user.contactInfo) return Promise.resolve();
    let companyInfo = null;
    if ('companies' in user.contactInfo) companyInfo = user.contactInfo.companies.find(c => c['uid'] == companyID);

    if (!companyInfo) {
      alert("Invalid company: " + companyID.toString());
      return Promise.resolve();
    }

    dispatch(activateCompany(companyInfo));
  };
};
const fetchContactInfo = () => {
  return (dispatch, getState) => {
    let user = getState().alpha.user;
    if (user.isUpdatingContact) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + "/contact/api/contact/0/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    let authorization = {};
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(updatingContact());
    return fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      }
    }).then(response => response.json()).then(json => dispatch(receiveContactInfo(json))).catch(error => dispatch(errorUpdatingContact(error)));
  };
};
const updateContactInfo = data => {
  return (dispatch, getState) => {
    let url = process.env.REACT_APP_GOAPP_API_URL + "/contact/api/contact/0/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(updatingContact());
    return fetch(url, {
      method: 'PUT',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      },
      body: JSON.stringify(data)
    }).then(response => {
      return response.json().then(json => {
        if (response.ok) dispatch(receiveContactInfo(json));else dispatch(errorUpdatingContact(JSON.stringify(json, null, 2)));
      });
    }).catch(error => dispatch(errorUpdatingContact(error)));
  };
}; // Synchronous Action Creators

const authenticating = () => ({
  type: ACTION$1.authenticating
});
const receiveTokenInfo = (authToken, tokenInfo) => ({
  type: ACTION$1.receiveTokenInfo,
  authToken,
  tokenInfo
});
const errorAuthenticating = error => ({
  type: ACTION$1.errorAuthenticating,
  error
});
const updatingContact = () => ({
  type: ACTION$1.updatingContact
});
const receiveContactInfo = json => {
  // Normalize
  let contactInfo = json;
  if (!json.first_name || json.first_name === undefined) contactInfo['first_name'] = '';
  if (!json.last_name || json.last_name === undefined) contactInfo['last_name'] = '';
  return {
    type: ACTION$1.receiveContactInfo,
    contactInfo: contactInfo,
    receivedAt: Date.now()
  };
};
const errorUpdatingContact = error => ({
  type: ACTION$1.errorUpdatingContact,
  error
});
const activateCompany = companyInfo => ({
  type: ACTION$1.activateCompany,
  companyInfo
}); // User reducer

function _authenticating(state, action) {
  return updateObject(state, {
    isAuthenticating: true
  });
}

function _completeLogout(state, action) {
  ls.remove('_userInfo');
  return updateObject(state, {
    isLoggedIn: false,
    authToken: null,
    tokenInfo: {}
  });
}

function _errorAuthenticating(state, action) {
  alert(action.error);
  return { ...state,
    isAuthenticating: false
  };
}

function _receiveTokenInfo(state, action) {
  let userInfo = action.tokenInfo; //  alert(JSON.stringify(userInfo, null, 2))
  // Store userInfo on local storage

  ls.set('_userInfo', userInfo);
  return { ...state,
    isAuthenticating: false,
    isLoggedIn: true,
    authToken: action.authToken,
    userInfo: userInfo
  };
}

function _updatingContact(state, action) {
  return { ...state,
    isUpdatingContact: true
  };
}

function _receiveContactInfo(state, action) {
  return { ...state,
    contactInfo: action.contactInfo,
    isUpdatingContact: false,
    lastContactUpdate: action.receivedAt
  };
}

function _errorUpdatingContact(state, action) {
  alert("Error Updating Contact."); //  alert(action.error)

  return { ...state,
    isUpdatingContact: false
  };
}

function _activateCompany(state, action) {
  //  alert("_activeCompany: " + JSON.stringify(action.companyInfo, null, 2))
  //  alert("state: " + JSON.stringify(state, null, 2))
  return { ...state,
    companyInfo: action.companyInfo
  };
}

const userReducer = (state = null, action) => {
  if (state == null) {
    // Get userInitial from local storage, but we're still in
    // not authenticated state, authToken is still null.
    // We'll use the info to auto authenticate to auth service
    state = userInitial;
    let userInfo = ls.get('_userInfo');
    if (userInfo && userInfo !== undefined) state.userInfo = userInfo;
  }

  const handlers = {
    [ACTION$1.authenticating]: _authenticating,
    [ACTION$1.errorAuthenticating]: _errorAuthenticating,
    [ACTION$1.receiveTokenInfo]: _receiveTokenInfo,
    [ACTION$1.completeLogout]: _completeLogout,
    [ACTION$1.updatingContact]: _updatingContact,
    [ACTION$1.receiveContactInfo]: _receiveContactInfo,
    [ACTION$1.errorUpdatingContact]: _errorUpdatingContact,
    [ACTION$1.activateCompany]: _activateCompany
  };
  if (handlers.hasOwnProperty(action.type)) return handlers[action.type](state, action);else return state;
};

const businessInfoInitial = {
  isFetching: false,
  isError: false,
  lastFetched: null,
  data: {}
}; // Actions

const ACTION$2 = {
  requestBusinessInfo: "requestBusinessInfo",
  receiveBusinessInfo: "receiveBusinessInfo",
  errorRequestBusinessInfo: "errorRequestBusinessInfo"
}; // Async action creator

const getBusinessInfo = (state, businessId = '0') => {
  if (businessId in state.alpha.business) return state.alpha.business[businessId];
  return businessInfoInitial;
};
const fetchBusinessInfo = (businessId = '0', refresh = false) => {
  return (dispatch, getState) => {
    let res = getBusinessInfo(getState(), businessId);
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve(); //    let url = process.env.REACT_APP_GOAPP_API_URL + "/business/api/business/" + businessId + "/"

    let url = process.env.REACT_APP_GOAPP_API_URL + "/directory/api/business/" + businessId + "/";
    let api_key = process.env.REACT_APP_GOAPP_API_KEY; //    alert(url)

    dispatch(requestBusinessInfo(businessId));
    return fetch(url, {
      headers: {
        'X-API-Key': api_key
      }
    }).then(response => response.json()).then(json => dispatch(receiveBusinessInfo(businessId, json))).catch(error => dispatch(errorRequestBusinessInfo(businessId, error)));
  };
}; // Synchronous Action Creators for Business Info

const requestBusinessInfo = businessId => ({
  type: ACTION$2.requestBusinessInfo,
  businessId
});
const receiveBusinessInfo = (businessId, json) => {
  return {
    type: ACTION$2.receiveBusinessInfo,
    businessId,
    result: json,
    receivedAt: Date.now()
  };
};
const errorRequestBusinessInfo = (businessId, error) => ({
  type: ACTION$2.errorRequestBusinessInfo,
  businessId,
  error
}); // Reducers for Business

const businessReducer = createReducer(businessInfoInitial, {
  [ACTION$2.requestBusinessInfo]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$2.receiveBusinessInfo]: (state, action) => {
    //      alert(JSON.stringify(action, null, 2))
    return { ...state,
      isFetching: false,
      isPartial: false,
      lastFetched: action.receivedAt,
      data: action.result
    };
  },
  [ACTION$2.errorRequestBusinessInfo]: (state, action) => {
    alert(action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  }
});

function businessByIdUpdater(state, action) {
  let key = action.businessId;
  return { ...state,
    [key]: businessReducer(state[key], action)
  };
}

const businessByIdReducer = createReducer({}, {
  [ACTION$2.requestBusinessInfo]: businessByIdUpdater,
  [ACTION$2.receiveBusinessInfo]: businessByIdUpdater,
  [ACTION$2.errorRequestBusinessInfo]: businessByIdUpdater
});

const WSSTATE = {
  Idle: "Idle",
  Connecting: "Connecting",
  Connected: "Connected",
  Disconnected: "Disconnected"
};
const conversationInitial = {
  key: null,
  isFetching: false,
  isError: false,
  lastFetched: null,
  lastUpdate: null,
  // Last message update
  data: {
    new_count: 0,
    unread_count: 0,
    message_count: 0
  },
  messages: []
};
const messageInitial = {
  isSending: false,
  lastUpdate: null,
  data: {}
};
const conversationListInitial = {
  isFetching: false,
  isError: false,
  lastFetched: null,
  isStarting: false,
  newConversationKey: null,
  stats: {
    new_count: 0,
    unread_count: 0,
    message_count: 0
  },
  conversations: [],
  wsState: WSSTATE.Idle,
  activeConversationKey: -1 // 0: New conversation

}; // Actions

const ACTION$3 = {
  wsStateChanged: "wsStateChanged",
  setActiveConversationKey: "setActiveConversationKey",
  startingConversation: "startingConversation",
  receiveNewConversation: "receiveNewConversation",
  errorStartingConversation: "errorStartingConversation",
  requestConversationList: "requestConversationList",
  receiveConversationList: "receiveConversationList",
  errorRequestConversationList: "errorRequestConversationList",
  conversationDeleted: "conversationDeleted",
  requestConversation: "requestConversation",
  receiveConversation: "receiveConversation",
  errorRequestConversation: "errorRequestConversation",
  requestMessages: "requestMessages",
  receiveMessages: "receiveMessages",
  errorRequestMessages: "errorRequestMessages",
  postMessage: "postMessage",
  receivePostMessageResult: "receivePostMessageResult",
  errorPostMessage: "errorPostMessage",
  receiveNewMessage: "receiveNewMessage",
  readAllMessages: "readAllMessages"
}; // Async action creator

const setActiveConversation = conversationKey => {
  return (dispatch, getState) => {
    dispatch(setActiveConversationKey(conversationKey));
  };
};
const fetchConversationList = (refresh = false) => {
  return (dispatch, getState) => {
    let res = getState().alpha.conversationList;
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/conversation/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestConversationList());
    return fetch(url, {
      headers: {
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      }
    }).then(response => response.json()).then(json => dispatch(receiveConversationList(json))).catch(error => dispatch(errorRequestConversationList(error)));
  };
};
const getNewConversation = state => {
  if (state.alpha.conversationList.newConversationKey) return getConversation(state, state.alpha.conversationList.newConversationKey);
  return null;
};
const getConversation = (state, conversationKey) => {
  let c = state.alpha.conversationList.conversations.find(c => c.key == conversationKey);
  if (c === undefined) c = null;
  return c;
};
const getLatestConversation = state => {
  if (state.alpha.conversationList.lastFetched && state.alpha.conversationList.conversations.length) return state.alpha.conversationList.conversations[0];
  return null;
};
const startNewConversation = () => {
  return (dispatch, getState) => {
    if (getState().alpha.conversationList.isStarting) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/conversation/start/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(startingConversation());
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      },
      body: JSON.stringify({})
    }).then(response => response.json()).then(json => dispatch(receiveNewConversation(json))).catch(error => dispatch(errorStartingConversation(error)));
  };
};
const deleteConversationIfEmpty = conversationKey => {
  return (dispatch, getState) => {
    let c = getConversation(getState(), conversationKey);
    if (c.messages.length > 0) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/conversation/" + c.key + "/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestMessages(conversationKey));
    return fetch(url, {
      method: 'DELETE',
      headers: {
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      }
    }).then(response => dispatch(conversationDeleted(conversationKey))).catch(error => dispatch(errorRequestMessages(conversationKey, error)));
  };
};
const fetchConversation = (conversationKey, refresh = false, withMessages = false, partial = false) => {
  return (dispatch, getState) => {
    let c = getConversation(getState(), conversationKey);
    if (!partial && c && (c.isFetching || c.lastFetched && !refresh)) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/conversation/" + c.key + "/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestConversation(conversationKey));
    return fetch(url, {
      headers: {
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      }
    }).then(response => response.json()).then(json => {
      if (withMessages) {
        // Set partial to true, so that isFetching flag will not reset to false
        dispatch(receiveConversation(conversationKey, json, true));
        dispatch(fetchMessages(conversationKey, true, false));
      } else dispatch(receiveConversation(conversationKey, json, false));
    }).catch(error => dispatch(errorRequestConversation(conversationKey, error)));
  };
};
const fetchMessages = (conversationKey, refresh = false, withConversation = false, partial = false) => {
  return (dispatch, getState) => {
    let c = getConversation(getState(), conversationKey);
    if (!partial && c && (c.isFetching || c.lastFetched && !refresh)) return Promise.resolve(); // 26 Nov: Try using conversation API to get messages so that we can get
    // conversation update (typing party) in one call.
    //    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/message/"

    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/conversation/" + c.key + "/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    url = url + "&message_size=50"; //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    dispatch(requestMessages(conversationKey));
    return fetch(url, {
      headers: {
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      }
    }).then(response => response.json()).then(json => {
      if (withConversation) {
        // Set partial to true, so that isFetching flag will not reset to false
        dispatch(receiveMessages(conversationKey, json, true));
        dispatch(fetchConversation(conversationKey, true, false, true));
      } else dispatch(receiveMessages(conversationKey, json, false));
    }).catch(error => dispatch(errorRequestMessages(conversationKey, error)));
  };
};
const sendMessage = (conversationKey, text, files = null) => {
  return (dispatch, getState) => {
    let c = getConversation(getState(), conversationKey);
    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/message/send/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    if (!text && !(files && files.length)) return Promise.resolve(); // c.lastFetched might null if user try to send message
    // while loading message contents for the first time.
    // Keep trying.
    //    if (c && c.lastFetched)

    if (c) url = url + "&conversation=" + c.data['uid'];else return Promise.resolve(); //    alert("sendMessage: " + url)
    // Create new Message object

    let message = { ...messageInitial,
      key: new Date().valueOf(),
      data: {
        body: text
      }
    }; //    alert("sendMessage: " + JSON.stringify(message, null, 2))
    //    alert("conversationKey: " + conversationKey)

    dispatch(postMessage(conversationKey, message));
    let formData = new FormData();
    formData.append('body', text);
    if (files) files.map((file, index) => {
      //      formData.append(`files${index}`, file)
      formData.append('attachments', file);
    });
    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        //          'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      },
      //        body: JSON.stringify(data)
      body: formData
    }).then(response => response.json()).then(json => {
      dispatch(receivePostMessageResult(conversationKey, message, json)); // Refresh conversation to quickly get operator typing_parties
      // This is a temporary hack until we implement websocket for
      // realtime push
      //        dispatch(fetchConversation(conversationKey, true))
    }).catch(error => dispatch(errorPostMessage(conversationKey, message)));
  };
};
const markReadAll = conversationKey => {
  return (dispatch, getState) => {
    let c = getConversation(getState(), conversationKey); // Must not check isFetching as we often do fetching and when it's fetching
    // we don't have any chance to mark read
    //    if (c.isFetching || !c.lastFetched)
    //      return Promise.resolve()

    let url = process.env.REACT_APP_GOAPP_API_URL + "/conversation/api/message/read_all/";
    url = url + "?visitor=" + getState().alpha.visitor.data.visitor_id;
    url = url + "&conversation=" + c.data['uid'];
    dispatch(readAllMessages(conversationKey)); //    alert("Fetching: " + url)

    let authorization = {};
    let user = getState().alpha.user;
    if (user.isLoggedIn) authorization = {
      'Authorization': 'jwt ' + user.authToken
    };
    return fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_GOAPP_API_KEY,
        ...authorization
      },
      body: JSON.stringify({})
    }).then(response => response.json()).then(json => {//        alert(JSON.stringify(json, null, 2))
    });
  };
}; // Synchronous Action Creators for Content Index

const wsStateChanged = state => ({
  type: ACTION$3.wsStateChanged,
  state: state
});
const setActiveConversationKey = conversationKey => ({
  type: ACTION$3.setActiveConversationKey,
  conversationKey
});
const startingConversation = () => ({
  type: ACTION$3.startingConversation
});
const receiveNewConversation = json => {
  return {
    type: ACTION$3.receiveNewConversation,
    result: json,
    receivedAt: Date.now()
  };
};
const errorStartingConversation = error => ({
  type: ACTION$3.errorStartingConversation,
  error
});
const requestConversationList = () => ({
  type: ACTION$3.requestConversationList
});
const receiveConversationList = json => {
  let result = json; //  alert("receiveConversationList")
  // alert(JSON.stringify(result, null, 2))

  return {
    type: ACTION$3.receiveConversationList,
    result: result,
    receivedAt: Date.now()
  };
};
const errorRequestConversationList = error => ({
  type: ACTION$3.errorRequestConversationList,
  error
});
const conversationDeleted = conversationKey => ({
  type: ACTION$3.conversationDeleted,
  conversationKey
});
const requestConversation = conversationKey => ({
  type: ACTION$3.requestConversation,
  conversationKey
});
const receiveConversation = (conversationKey, json, partial = false) => {
  let result = json; //  alert(JSON.stringify(json, null, 2))

  return {
    type: ACTION$3.receiveConversation,
    conversationKey,
    result: result,
    receivedAt: Date.now(),
    partial: partial
  };
};
const errorRequestConversation = (conversationKey, error) => ({
  type: ACTION$3.errorRequestConversation,
  conversationKey,
  error
});
const requestMessages = conversationKey => ({
  type: ACTION$3.requestMessages,
  conversationKey
});
const receiveMessages = (conversationKey, json, partial = false) => {
  let result = json; //  alert(JSON.stringify(json, null, 2))

  return {
    type: ACTION$3.receiveMessages,
    conversationKey,
    //    result: result,
    conversation: result,
    result: result['messages'],
    receivedAt: Date.now(),
    partial: partial
  };
};
const errorRequestMessages = (conversationKey, error) => ({
  type: ACTION$3.errorRequestMessages,
  conversationKey,
  error
});
const postMessage = (conversationKey, message) => ({
  type: ACTION$3.postMessage,
  conversationKey,
  message
});
const receivePostMessageResult = (conversationKey, message, json) => {
  let result = json;
  return {
    type: ACTION$3.receivePostMessageResult,
    conversationKey,
    message,
    result: result,
    receivedAt: Date.now()
  };
};
const errorPostMessage = (conversationKey, message, error) => ({
  type: ACTION$3.errorPostMessage,
  conversationKey,
  message
});
const receiveNewMessage = (conversationKey, message) => {
  //  alert(JSON.stringify(message, null, 2))
  return {
    type: ACTION$3.receiveNewMessage,
    conversationKey,
    result: message,
    receivedAt: Date.now()
  };
};
const readAllMessages = conversationKey => ({
  type: ACTION$3.readAllMessages,
  conversationKey
}); // Reducers for Conversation

const conversationReducer = createReducer(conversationInitial, {
  [ACTION$3.requestConversation]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$3.receiveConversation]: (state, action) => {
    return { ...state,
      isFetching: action.partial ? state.isFetching : false,
      lastFetched: action.partial ? state.lastFetched : action.receivedAt,
      data: action.result
    };
  },
  [ACTION$3.errorRequestConversation]: (state, action) => {
    alert(action.error);
    return { ...state,
      isFetchingMessages: false,
      isError: true
    };
  },
  [ACTION$3.requestMessages]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$3.receiveMessages]: (state, action) => {
    //      alert(JSON.stringify(action.result, null, 2))
    // Keep pending messages
    let pending = state.messages.reduce((all, item) => {
      if (item.isSending) return [...all, item];else return all;
    }, []);
    let messages = action.result.map(data => {
      return { ...messageInitial,
        // Same as conversation update time.
        key: data['id'],
        lastUpdate: action.receivedAt,
        data: data
      };
    });
    return { ...state,
      isFetching: action.partial ? state.isFetching : false,
      lastFetched: action.partial ? state.receivedAt : action.receivedAt,
      data: action.conversation,
      messages: [...messages, ...pending]
    };
  },
  [ACTION$3.receiveNewMessage]: (state, action) => {
    //      alert(JSON.stringify(action.result, null, 2))
    let newMessage = action.result;
    let discard = false;
    let messages = state.messages.map(message => {
      if (message.key == newMessage['id']) {
        discard = true;
        return { ...message,
          data: newMessage
        };
      } //        if (message.isSending)
      //          discard = true


      return message;
    });

    if (!discard) {
      messages.push({ ...messageInitial,
        key: newMessage['id'],
        lastUpdate: action.receivedAt,
        data: { ...newMessage,
          is_new: true
        }
      });
    }

    return { ...state,
      messages: messages,
      data: action.result.conversation
    };
  },
  [ACTION$3.readAllMessages]: (state, action) => {
    return { ...state,
      data: { ...state.data,
        new_count: 0
      }
    };
  },
  [ACTION$3.errorRequestMessages]: (state, action) => {
    alert(action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  },
  [ACTION$3.postMessage]: (state, action) => {
    let messages = [...state.messages, { ...action.message,
      isSending: true
    }];
    return { ...state,
      messages
    };
  },
  [ACTION$3.receivePostMessageResult]: (state, action) => {
    //      alert("receivePostMessageResult: " + JSON.stringify(action.result, null, 2))
    let messages;
    let found = state.messages.find(item => item.key == action.result.id);
    if (found) messages = state.messages.reduce((p, n) => {
      if (n.key == action.message.key) return p;else return [...p, n];
    }, []);else messages = state.messages.map(item => {
      if (item.key == action.message.key) return { ...item,
        key: action.result.id,
        // Update to new key for new message
        isSending: false,
        lastUpdate: action.receivedAt,
        data: action.result
      };
      return item;
    });
    let unread_count = 1;
    if (state.data && state.data.unread_count !== undefined) unread_count = state.data.unread_count + 1;

    if (state.key == 0 && !state.lastFetched) {
      return { ...state,
        messages,
        key: action.result.conversation.uid,
        // Update with new key          
        data: { ...action.result.conversation,
          unread_count: unread_count
        },
        lastFetched: action.receivedAt
      };
    } else {
      return { ...state,
        data: { ...state.data,
          unread_count: unread_count
        },
        messages
      };
    }
  },
  [ACTION$3.errorPostMessage]: (state, action) => {
    alert("Error Post Message: " + action.error);
    return { ...state,
      isSending: false
    };
  }
});
const conversationListReducer = createReducer(conversationListInitial, {
  [ACTION$3.wsStateChanged]: (state, action) => {
    return { ...state,
      wsState: action.state
    };
  },
  [ACTION$3.setActiveConversationKey]: (state, action) => {
    return { ...state,
      activeConversationKey: action.conversationKey
    };
  },
  [ACTION$3.requestConversationList]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$3.receiveConversationList]: (state, action) => {
    // Create record for each conversation in response
    let conversations = action.result.map(data => {
      // Keep last fetched messages
      let c = state.conversations.find(c => {
        return c.key == data.uid;
      });
      let messages = c ? c.messages : [];

      if (data.last_message) {
        if (!messages.find(c => {
          return c.key == data.last_message.id;
        })) messages.push({ ...messageInitial,
          key: data.last_message.id,
          data: data.last_message
        });
      }

      return { ...conversationInitial,
        key: data.uid,
        data,
        messages
      };
    });
    let message_count = 0;
    let new_count = 0;
    let unread_count = 0;
    conversations.forEach((c, index) => {
      message_count += c.data.message_count === undefined ? 0 : c.data.message_count;
      new_count += c.data.new_count === undefined ? 0 : c.data.new_count;
      unread_count += c.data.unread_count === undefined ? 0 : c.data.unread_count;
    }); //      alert(JSON.stringify(conversations, null, 2))

    return { ...state,
      isFetching: false,
      lastFetched: action.receivedAt,
      conversations: conversations,
      stats: {
        message_count: message_count,
        new_count: new_count,
        unread_count: unread_count
      }
    };
  },
  [ACTION$3.errorRequestConversationList]: (state, action) => {
    alert("Request conversation list failed: " + action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  },
  [ACTION$3.startingConversation]: (state, action) => {
    return { ...state,
      isStarting: true,
      newConversationKey: null
    };
  },
  [ACTION$3.receiveNewConversation]: (state, action) => {
    let c = { ...conversationInitial,
      key: action.result.uid,
      data: action.result
    }; //      alert("receiveNewConversation")
    //      alert(JSON.stringify(c, null, 2))

    return { ...state,
      isStarting: false,
      newConversationKey: c.key,
      conversations: [c, ...state.conversations]
    };
  },
  [ACTION$3.errorStartingConversation]: (state, action) => {
    alert(action.error);
    return { ...state,
      isStarting: false,
      isError: true
    };
  },
  [ACTION$3.conversationDeleted]: (state, action) => {
    let conversations = state.conversations.reduce((all, c) => {
      if (c.key == action.conversationKey) return all;else return [...all, c];
    }, []);
    return { ...state,
      newConversationKey: null,
      conversations
    };
  },
  '*': (state, action) => {
    if (action.type in ACTION$3) {
      //        alert(JSON.stringify(action, null, 2))
      let conversation = state.conversations.find(c => c.key == action.conversationKey);

      if (conversation) {
        let newConversation = conversationReducer(conversation, action);
        let newRecords = state.conversations.map(c => {
          if (c.key == action.conversationKey) return newConversation;
          return c;
        });
        let message_count = 0;
        let new_count = 0;
        let unread_count = 0;
        newRecords.forEach((c, index) => {
          message_count += c.data.message_count === undefined ? 0 : c.data.message_count;
          new_count += c.data.new_count === undefined ? 0 : c.data.new_count;
          unread_count += c.data.unread_count === undefined ? 0 : c.data.unread_count;
        });
        return { ...state,
          conversations: newRecords,
          stats: {
            message_count: message_count,
            new_count: new_count,
            unread_count: unread_count
          }
        };
      }
    }

    return state;
  }
});

const wsConnect = host => ({
  type: 'WS_CONNECT',
  host
});
const wsConnected = host => ({
  type: 'WS_CONNECTED',
  host
});
const wsDisconnected = host => ({
  type: 'WS_DISCONNECTED',
  host
});
const wsSend = (command, data) => ({
  type: 'WS_SEND',
  command,
  data
});
const conversationMiddleware = () => {
  let socket = null;

  const onOpen = store => event => {
    console.log('websocket open', event.target.url);
    store.dispatch(wsConnected(event.target.url));
  };

  const onClose = store => () => {
    store.dispatch(wsDisconnected());
  };

  const onMessage = store => event => {
    const payload = JSON.parse(event.data);
    console.log('receiving server message');

    switch (payload.type) {
      case 'new_message':
        store.dispatch(receiveNewMessage(payload.data.conversation.uid, payload.data));
        break;
    }
  }; // the middleware part of this function


  return store => next => action => {
    switch (action.type) {
      case 'WS_CONNECT':
        if (socket !== null) {
          //          socket.close();
          break;
        } //        alert(action.host)
        // connect to the remote host


        socket = new WebSocket(action.host); //        store.dispatch(wsConnecting);

        store.dispatch(wsStateChanged(WSSTATE.Connecting)); // websocket handlers

        socket.onmessage = onMessage(store);
        socket.onclose = onClose(store);
        socket.onopen = onOpen(store);
        break;

      case 'WS_DISCONNECT':
        if (socket !== null) {
          socket.close();
        }

        socket = null;
        console.log('websocket closed');
        break;

      case 'WS_START': // Send start command

      case 'WS_CONNECTED':
        store.dispatch(wsStateChanged(WSSTATE.Connected));
        break;

      case 'WS_CONNECTING':
        store.dispatch(wsStateChanged(WSSTATE.Connecting));
        break;

      case 'WS_DISCONNECTED':
        store.dispatch(wsStateChanged(WSSTATE.Disconnected));
        socket = null;
        break;

      case 'WS_SEND':
        if (socket == null) break;
        console.log('sending a message: ', action.command);
        socket.send(JSON.stringify({
          command: action.command,
          data: action.data
        }));
        break;

      default:
        console.log('the next action:', action);
        return next(action);
    }
  };
};
var conversation = conversationMiddleware();

const styles = theme => ({
  root: {
    paddingTop: theme.spacing(2)
  },
  list: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  },
  avatar: {
    width: 60,
    height: 60,
    marginRight: theme.spacing.unit * 2
  },
  pageTitle: {
    color: '#000',
    fontWeight: 800,
    padding: theme.spacing.unit,
    paddingTop: theme.spacing(2),
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  sectionHeader: {
    marginBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 2,
    color: '#999'
  },
  sectionFooter: {
    marginTop: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 2
  },
  sectionDivider: {
    minHeight: theme.spacing.unit * 2
  },
  sectionBody: {
    backgroundColor: theme.palette.background.paper,
    width: '100%'
  },
  sectionContent: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    display: 'flex',
    alignItems: 'center',
    width: '100'
  },
  sectionContentAction: {},
  bottomPadding: {
    minHeight: 100
  },
  headerChat: {
    position: 'fixed',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: 'inherit',
    background: 'white',
    zIndex: '100',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  labelChat: {
    paddingLeft: theme.spacing(2) // [theme.breakpoints.down('xs')]:{
    //   paddingLeft: 0
    // }

  },
  iconClose: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      position: 'fixed',
      right: '10px',
      top: '16px',
      zIndex: 101
    }
  },
  accountName: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'initial'
    }
  }
});

const ConversationItem = ({
  classes,
  business,
  item,
  onClick
}) => {
  let title = business.name;
  let sender = "";
  let preview = "...";
  let date = "";
  let stat = ""; //  alert(JSON.stringify(item, null, 2))

  if (item.messages.length) {
    title = item.data.parties.map(p => {
      if (p.agent) {
        let name = p.agent.first_name;
        if (p.agent.last_name && p.agent.last_name !== undefined) name += " " + p.agent.last_name;
        if (p.agent.is_service_user) name += ""; //" (Bot)"
        else name += " (Agent)"; //          name += " (" + business.name + ")"

        return name;
      } else return null;
    }).reduce((p, n) => {
      if (p && n) return p + ", " + n;else if (n) return n;else return p;
    });
    if (!title && item.data.queue) title = item.data.queue.name;
    if (!title || title.length <= 0) title = "You"; //    alert(JSON.stringify(item, null, 2))

    let msg = item.messages[item.messages.length - 1];
    preview = msg.data.body;

    if (msg.data.attachments && msg.data.attachments !== undefined && msg.data.attachments.length > 0) {
      preview = "Photo";
    }

    if (preview.startsWith("{") && preview.endsWith("}")) preview = JSON.parse(preview)['text'];
    if (preview) preview = preview.replace(/(?:__|[*#])|\[(.*?)\]\(.*?\)/gm, '$1');
    if (msg.isSending) date = "Sending...";else {
      if (msg.data.sent_at) date = moment(msg.data.sent_at).fromNow(true);
      if (msg.data.sender.contact) sender = "You";
    } //    if (msg.data.agent)
    //      sender = msg.data.agent.first_name
    //    else if (msg.data.service)
    //      sender = msg.data.service.first_name
  }

  let newCount = item.data.new_count;
  if (item.data.new_count) stat = " (New)";else if (item.data.unread_count) stat = " (Not Read)";else if (item.messages.length) //    stat = " (Read)"   
    stat = "";
  return React.createElement(ListItem, {
    alignItems: "flex-start",
    onClick: () => onClick(item)
  }, React.createElement(ListItemAvatar, null, React.createElement(Avatar, {
    alt: "You",
    src: ""
  })), React.createElement(ListItemText, {
    primary: React.createElement(React.Fragment, null, React.createElement(Typography, null, title)),
    secondary: React.createElement(React.Fragment, null, React.createElement(Typography, {
      component: "p",
      variant: "body2",
      className: classes.inline,
      color: "textPrimary",
      noWrap: false
    }, sender && React.createElement(React.Fragment, null, " ", sender, ": "), preview), React.createElement("br", null), date, " ", stat)
  }), React.createElement(ListItemSecondaryAction, null, React.createElement(Badge, {
    color: "primary",
    badgeContent: newCount
  }, "\xA0")));
};

const ConversationList = ({
  classes,
  business,
  conversations,
  onClick
}) => React.createElement(Box, {
  className: classes.sectionBody
}, React.createElement(Divider, null), conversations.length > 0 ? React.createElement(List, {
  className: classes.list
}, conversations.length ? conversations.map(item => React.createElement(ConversationItem, {
  classes: classes,
  business: business,
  item: item,
  onClick: () => onClick(item)
})).reduce((prev, next) => [prev, React.createElement(Divider, {
  variant: "inset",
  component: "li"
}), next]) : React.createElement(React.Fragment, null)) : React.createElement(Box, {
  width: "100%",
  className: classes.sectionContent
}, React.createElement(Box, {
  flexGrow: 1,
  color: "#999"
}, React.createElement(Typography, {
  component: "div",
  variant: "body1"
}, "Belum ada riwayat chat."))), React.createElement(Divider, null));

const ChatHeader = ({
  classes,
  business,
  showConversation,
  wsState
}) => {
  let state = "Disconnected";
  if (wsState == WSSTATE.Connected) state = "You are online";else if (wsState == WSSTATE.Connecting) state = "Connecting...";
  return React.createElement(Box, {
    className: classes.chatHeader
  }, React.createElement(Box, {
    width: "100%",
    className: classes.sectionContent,
    display: "flex",
    flexDirection: "column"
  }, React.createElement(Box, {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }, React.createElement(Box, {
    flexGrow: 1
  }, React.createElement(Typography, {
    variant: "h6",
    className: classes.accountName
  }, React.createElement(Box, {
    fontWeight: 800,
    color: "#000"
  }, business.name)), React.createElement(Typography, {
    variant: "p",
    className: classes.accountName
  }, state)), React.createElement(Box, {
    width: "10rem"
  })), React.createElement(Box, {
    width: "100%",
    mt: 2,
    display: "flex"
  }, React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: () => showConversation(0)
  }, "Mulai Chat Baru")), React.createElement(Box, {
    width: "100%",
    display: "flex",
    display: "none"
  }, React.createElement(Box, null, React.createElement(Avatar, {
    src: business.avatar == undefined ? null : business.avatar.image_url,
    className: classes.avatar,
    border: 1
  })), React.createElement(Box, {
    flexGrow: 1
  }, React.createElement(Typography, {
    component: "div",
    variant: "body1",
    gutterBottom: true
  }, business.name), React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: () => showConversation(0)
  }, "Mulai Chat Baru")))));
};

const InboxView = ({
  theme,
  classes,
  history,
  business,
  lastFetched,
  wsState,
  fetchConversationList,
  isFetching,
  conversations,
  newConversation,
  openChat
}) => {
  const [hasBottomMenu, setHasBottomMenu] = useState(false);
  useEffect(() => {}); // This will be called on component init  

  useEffect(() => {
    fetchConversationList();
    return () => {};
  }, []); // useEffect(() => {
  //   navigationContext.setLoading(isFetching)
  //   return () => {
  //     navigationContext.setLoading(false)
  //   }
  // }, [isFetching])

  let sm = useMediaQuery(theme.breakpoints.up('sm'));

  const showConversation = conversationKey => {
    openChat(conversationKey);
    /*    
        if (wsState != WSSTATE.Connected) {
          alert("Can not start chat while you are not online. Please check your internet connection.")
          return
        }
    
        setIsChat(true)
        setIsInbox(false)
        setKeyConversation(conversationKey)
    */
    //    alert('showConversation:'+ conversationKey)
    //    history.push("/chat/" + conversationKey)
    // if (sm)
    //   navigationContext.showPopupContent(
    //     <Chat conversationKey={conversationKey} openChat={(key)=>showConversation(key)} />
    //     )
    // else
    //   showPopup(
    //     <Chat conversationKey={conversationKey} openChat={(key)=>showConversation(key)} />
    //     )
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Box, {
    className: classes.pageTitle
  }), React.createElement(ChatHeader, {
    classes: classes,
    business: business,
    showConversation: showConversation,
    wsState: wsState
  }), React.createElement("div", {
    className: classes.sectionDivider
  }), React.createElement(Box, {
    className: classes.sectionHeader,
    di: true
  }, React.createElement(Typography, {
    variant: "body1"
  }, "Riwayat Chat")), React.createElement(ConversationList, {
    classes: classes,
    business: business,
    conversations: conversations,
    onClick: conversation => showConversation(conversation.key)
  }));
};

const mapStateToProps = (state, ownProps) => {
  return { ...state.alpha.conversationList,
    business: getBusinessInfo(state).data
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchConversationList: () => {
      dispatch(fetchConversationList(true));
    }
  };
};

var Inbox = withRouter(withStyles(styles, {
  withTheme: true
})(connect(mapStateToProps, mapDispatchToProps)(InboxView)));

const useStyles = makeStyles(({
  palette,
  spacing
}) => {
  const radius = spacing(2.5);
  const size = spacing(6);
  const rightBgColor = palette.primary.main; // if you want the same as facebook messenger, use this color '#09f'

  return {
    avatar: {
      width: size,
      height: size,
      backgroundColor: '#ddd'
    },
    msg: {
      padding: spacing(1, 2),
      borderRadius: 4,
      marginBottom: 4,
      display: 'inline-block',
      wordBreak: 'break-word',
      fontFamily: // eslint-disable-next-line max-len
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
    },
    card: {
      marginBottom: 4
    },
    status: {
      padding: spacing(0, 2)
    },
    leftRow: {
      textAlign: 'left'
    },
    left: {
      borderTopRightRadius: radius,
      borderBottomRightRadius: radius,
      backgroundColor: palette.grey[100]
    },
    leftFirst: {
      borderTopLeftRadius: radius
    },
    leftLast: {
      borderBottomLeftRadius: radius
    },
    rightRow: {
      textAlign: 'right'
    },
    right: {
      borderTopLeftRadius: radius,
      borderBottomLeftRadius: radius,
      backgroundColor: rightBgColor,
      color: palette.common.white
    },
    rightFirst: {
      borderTopRightRadius: radius
    },
    rightLast: {
      borderBottomRightRadius: radius
    }
  };
});

const ChatMessage = ({
  avatar,
  messages,
  cardComponents,
  side,
  status,
  animated
}) => {
  const classes = useStyles();

  const attachClass = index => {
    if (index === 0) {
      return classes[`${side}First`];
    }

    if (index === messages.length - 1) {
      return classes[`${side}Last`];
    }

    return '';
  };

  return React.createElement(Reveal, {
    duration: animated ? 500 : 0
  }, React.createElement(Grid, {
    container: true,
    spacing: 2,
    justify: side === 'right' ? 'flex-end' : 'flex-start'
  },  side === 'left' && React.createElement(Grid, {
    item: true
  }, React.createElement(Avatar, {
    className: classes.avatar,
    src: avatar
  })), React.createElement(Grid, {
    item: true,
    xs: 9
  }, messages.map((msg, i) => React.createElement("div", {
    className: classes[`${side}Row`]
  }, React.createElement(Typography, {
    className: `${classes.msg} ${classes[side]} ${attachClass(i)}`
  }, msg))), cardComponents && React.createElement("div", null, cardComponents.map(card => React.createElement("div", {
    className: classes.card
  }, card))), status && React.createElement("div", {
    className: classes[`${side}Row`]
  }, React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    className: classes.status
  }, status)))));
};

ChatMessage.propTypes = {
  avatar: PropTypes.string,
  messages: PropTypes.arrayOf(PropTypes.string),
  status: PropTypes.string,
  side: PropTypes.oneOf(['left', 'right'])
};
ChatMessage.defaultProps = {
  avatar: '',
  messages: [],
  side: 'left',
  status: ''
};

const styles$1 = theme => ({
  root: {},
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9

  }
});

const CardMessage = ({
  classes,
  theme,
  title,
  subtitle,
  images,
  buttons,
  onClick
}) => {
  return React.createElement(Card, {
    className: classes.root
  }, React.createElement(CardMedia, {
    className: classes.media,
    image: images[0].image_url,
    title: title
  }), React.createElement(CardContent$1, null, React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    component: "p"
  }, title), React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    component: "p"
  }, subtitle)), buttons && React.createElement(React.Fragment, null, React.createElement(Divider, null), React.createElement(CardActionArea, null, React.createElement(Box, {
    flex: 1,
    flexDirection: "column"
  }, buttons.map(btn => React.createElement(Button, {
    variant: "text",
    color: "primary",
    fullWidth: true,
    onClick: () => onClick(btn)
  }, btn.title))))));
};

var CardContent = withStyles(styles$1, {
  withTheme: true
})(CardMessage);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactLoading = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(typeof self !== 'undefined' ? self : commonjsGlobal, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (process.env.NODE_ENV !== 'production') {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(0);
  var warning = __webpack_require__(3);
  var ReactPropTypesSecret = __webpack_require__(4);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(8);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _svg = __webpack_require__(14);

var svgSources = _interopRequireWildcard(_svg);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loading = function (_Component) {
  _inherits(Loading, _Component);

  function Loading() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Loading);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loading.__proto__ || Object.getPrototypeOf(Loading)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      delayed: _this.props.delay > 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Loading, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var delay = this.props.delay;
      var delayed = this.state.delayed;


      if (delayed) {
        this.timeout = setTimeout(function () {
          _this2.setState({
            delayed: false
          });
        }, delay);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var timeout = this.timeout;


      if (timeout) {
        clearTimeout(timeout);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          delay = _props.delay,
          type = _props.type,
          height = _props.height,
          width = _props.width,
          restProps = _objectWithoutProperties(_props, ['color', 'delay', 'type', 'height', 'width']);

      var selectedType = this.state.delayed ? 'blank' : type;
      var svg = svgSources[selectedType];
      var style = {
        fill: color,
        height: height,
        width: width
      };

      return _react2.default.createElement('div', _extends({
        style: style,
        dangerouslySetInnerHTML: { __html: svg }
      }, restProps));
    }
  }]);

  return Loading;
}(_react.Component);

Loading.propTypes = {
  color: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  type: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
Loading.defaultProps = {
  color: '#fff',
  delay: 0,
  type: 'balls',
  height: 64,
  width: 64
};
exports.default = Loading;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(9);
} else {
  module.exports = __webpack_require__(10);
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(2),n=__webpack_require__(0),p=__webpack_require__(5),q=__webpack_require__(1),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e);}var D={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D;}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState");};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D;}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k;}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return {$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return "object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return "$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return {result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a);}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0;}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c);}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++);}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a));}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b);}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b);},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return {current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return {$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c]);}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k;}return {$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {
/** @license React v16.3.2
 * react.development.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {

var _assign = __webpack_require__(2);
var invariant = __webpack_require__(0);
var emptyObject = __webpack_require__(5);
var warning = __webpack_require__(3);
var emptyFunction = __webpack_require__(1);
var checkPropTypes = __webpack_require__(6);

// TODO: this is special because it gets imported during build.

var ReactVersion = '16.3.2';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol['for'];

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol['for']('react.element') : 0xeac7;
var REACT_CALL_TYPE = hasSymbol ? Symbol['for']('react.call') : 0xeac8;
var REACT_RETURN_TYPE = hasSymbol ? Symbol['for']('react.return') : 0xeac9;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol['for']('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol['for']('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol['for']('react.strict_mode') : 0xeacc;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol['for']('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol['for']('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol['for']('react.async_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol['for']('react.forward_ref') : 0xead0;

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';

function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable === 'undefined') {
    return null;
  }
  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }
  return null;
}

// Relying on the `invariant()` implementation lets us
// have preserve the format and params in the www builds.

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + '.' + callerName;
    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }
    warning(false, "Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);
    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

/**
 * Base class helpers for the updating state of a component.
 */
function Component(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
Component.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : void 0;
  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        lowPriorityWarning$1(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
        return undefined;
      }
    });
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;

/**
 * Convenience component with default shallow equality check for sCU.
 */
function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
// Avoid an extra prototype jump for these methods.
_assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };
  {
    Object.seal(refObject);
  }
  return refObject;
}

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

var hasOwnProperty = Object.prototype.hasOwnProperty;

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown = void 0;
var specialPropRefWarningShown = void 0;

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
      warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
      warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    });
    // self and source are DEV only properties.
    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    });
    // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.
    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */
function createElement(type, config, children) {
  var propName = void 0;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}

/**
 * Return a function that produces ReactElements of a given type.
 * See https://reactjs.org/docs/react-api.html#createfactory
 */


function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
}

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */
function cloneElement(element, config, children) {
  !!(element === null || element === undefined) ? invariant(false, 'React.cloneElement(...): The argument must be a React element, but you passed %s.', element) : void 0;

  var propName = void 0;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps = void 0;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}

/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var ReactDebugCurrentFrame = {};

{
  // Component that is being worked on
  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var impl = ReactDebugCurrentFrame.getCurrentStack;
    if (impl) {
      return impl();
    }
    return null;
  };
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */
function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

var POOL_SIZE = 10;
var traverseContextPool = [];
function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
  if (traverseContextPool.length) {
    var traverseContext = traverseContextPool.pop();
    traverseContext.result = mapResult;
    traverseContext.keyPrefix = keyPrefix;
    traverseContext.func = mapFunction;
    traverseContext.context = mapContext;
    traverseContext.count = 0;
    return traverseContext;
  } else {
    return {
      result: mapResult,
      keyPrefix: keyPrefix,
      func: mapFunction,
      context: mapContext,
      count: 0
    };
  }
}

function releaseTraverseContext(traverseContext) {
  traverseContext.result = null;
  traverseContext.keyPrefix = null;
  traverseContext.func = null;
  traverseContext.context = null;
  traverseContext.count = 0;
  if (traverseContextPool.length < POOL_SIZE) {
    traverseContextPool.push(traverseContext);
  }
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;
      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }
    }
  }

  if (invokeCallback) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child = void 0;
  var nextName = void 0;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (typeof iteratorFn === 'function') {
      {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          !didWarnAboutMaps ? warning(false, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.%s', ReactDebugCurrentFrame.getStackAddendum()) : void 0;
          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step = void 0;
      var ii = 0;
      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
      }
    } else if (type === 'object') {
      var addendum = '';
      {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
      }
      var childrenString = '' + children;
      invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum);
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof component === 'object' && component !== null && component.key != null) {
    // Explicit key
    return escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  releaseTraverseContext(traverseContext);
}

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  releaseTraverseContext(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, emptyFunction.thatReturnsNull, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !isValidElement(children) ? invariant(false, 'React.Children.only expected to receive a single React element child.') : void 0;
  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      !(calculateChangedBits === null || typeof calculateChangedBits === 'function') ? warning(false, 'createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits) : void 0;
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    _defaultValue: defaultValue,
    _currentValue: defaultValue,
    _changedBits: 0,
    // These are circular
    Provider: null,
    Consumer: null
  };

  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };
  context.Consumer = context;

  {
    context._currentRenderer = null;
  }

  return context;
}

function forwardRef(render) {
  {
    !(typeof render === 'function') ? warning(false, 'forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render) : void 0;
  }

  return {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };
}

var describeComponentFrame = function (name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
};

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_ASYNC_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

function getComponentName(fiber) {
  var type = fiber.type;

  if (typeof type === 'function') {
    return type.displayName || type.name;
  }
  if (typeof type === 'string') {
    return type;
  }
  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'ReactFragment';
    case REACT_PORTAL_TYPE:
      return 'ReactPortal';
    case REACT_CALL_TYPE:
      return 'ReactCall';
    case REACT_RETURN_TYPE:
      return 'ReactReturn';
  }
  if (typeof type === 'object' && type !== null) {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        var functionName = type.render.displayName || type.render.name || '';
        return functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef';
    }
  }
  return null;
}

/**
 * ReactElementValidator provides a wrapper around a element factory
 * which validates the props passed to the element. This is intended to be
 * used only in DEV and could be replaced by a static type checker for languages
 * that support it.
 */

var currentlyValidatingElement = void 0;
var propTypesMisspellWarningShown = void 0;

var getDisplayName = function () {};
var getStackAddendum = function () {};

{
  currentlyValidatingElement = null;

  propTypesMisspellWarningShown = false;

  getDisplayName = function (element) {
    if (element == null) {
      return '#empty';
    } else if (typeof element === 'string' || typeof element === 'number') {
      return '#text';
    } else if (typeof element.type === 'string') {
      return element.type;
    } else if (element.type === REACT_FRAGMENT_TYPE) {
      return 'React.Fragment';
    } else {
      return element.type.displayName || element.type.name || 'Unknown';
    }
  };

  getStackAddendum = function () {
    var stack = '';
    if (currentlyValidatingElement) {
      var name = getDisplayName(currentlyValidatingElement);
      var owner = currentlyValidatingElement._owner;
      stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner));
    }
    stack += ReactDebugCurrentFrame.getStackAddendum() || '';
    return stack;
  };
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current);
    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }
  return '';
}

function getSourceInfoErrorAddendum(elementProps) {
  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
    var source = elementProps.__source;
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }
  return '';
}

/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */
var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
    if (parentName) {
      info = '\n\nCheck the top-level render call using <' + parentName + '>.';
    }
  }
  return info;
}

/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */
function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }
  element._store.validated = true;

  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }
  ownerHasKeyUseWarning[currentComponentErrorInfo] = true;

  // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.
  var childOwner = '';
  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = ' It was passed a child from ' + getComponentName(element._owner) + '.';
  }

  currentlyValidatingElement = element;
  {
    warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, getStackAddendum());
  }
  currentlyValidatingElement = null;
}

/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */
function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];
      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);
    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step = void 0;
        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}

/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */
function validatePropTypes(element) {
  var componentClass = element.type;
  if (typeof componentClass !== 'function') {
    return;
  }
  var name = componentClass.displayName || componentClass.name;
  var propTypes = componentClass.propTypes;
  if (propTypes) {
    currentlyValidatingElement = element;
    checkPropTypes(propTypes, element.props, 'prop', name, getStackAddendum);
    currentlyValidatingElement = null;
  } else if (componentClass.PropTypes !== undefined && !propTypesMisspellWarningShown) {
    propTypesMisspellWarningShown = true;
    warning(false, 'Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
  }
  if (typeof componentClass.getDefaultProps === 'function') {
    !componentClass.getDefaultProps.isReactClassApproved ? warning(false, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
  }
}

/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */
function validateFragmentProps(fragment) {
  currentlyValidatingElement = fragment;

  var keys = Object.keys(fragment.props);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key !== 'children' && key !== 'key') {
      warning(false, 'Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.%s', key, getStackAddendum());
      break;
    }
  }

  if (fragment.ref !== null) {
    warning(false, 'Invalid attribute `ref` supplied to `React.Fragment`.%s', getStackAddendum());
  }

  currentlyValidatingElement = null;
}

function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type);

  // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.
  if (!validType) {
    var info = '';
    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendum(props);
    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    info += getStackAddendum() || '';

    var typeString = void 0;
    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else {
      typeString = typeof type;
    }

    warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
  }

  var element = createElement.apply(this, arguments);

  // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.
  if (element == null) {
    return element;
  }

  // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)
  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === REACT_FRAGMENT_TYPE) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}

function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;
  // Legacy hook: remove it
  {
    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        lowPriorityWarning$1(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}

function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);
  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }
  validatePropTypes(newElement);
  return newElement;
}

var React = {
  Children: {
    map: mapChildren,
    forEach: forEachChildren,
    count: countChildren,
    toArray: toArray,
    only: onlyChild
  },

  createRef: createRef,
  Component: Component,
  PureComponent: PureComponent,

  createContext: createContext,
  forwardRef: forwardRef,

  Fragment: REACT_FRAGMENT_TYPE,
  StrictMode: REACT_STRICT_MODE_TYPE,
  unstable_AsyncMode: REACT_ASYNC_MODE_TYPE,

  createElement: createElementWithValidation,
  cloneElement: cloneElementWithValidation,
  createFactory: createFactoryWithValidation,
  isValidElement: isValidElement,

  version: ReactVersion,

  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
    ReactCurrentOwner: ReactCurrentOwner,
    // Used by renderers to avoid bundling object-assign twice in UMD bundles:
    assign: _assign
  }
};

{
  _assign(React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, {
    // These should not be included in production.
    ReactDebugCurrentFrame: ReactDebugCurrentFrame,
    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
    // TODO: remove in React 17.0.
    ReactComponentTreeHook: {}
  });
}



var React$2 = Object.freeze({
	default: React
});

var React$3 = ( React$2 && React ) || React$2;

// TODO: decide on the top-level export form.
// This is hacky but makes it work with both Rollup and Jest.
var react = React$3['default'] ? React$3['default'] : React$3;

module.exports = react;
  })();
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(13)();
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(3);
var assign = __webpack_require__(2);

var ReactPropTypesSecret = __webpack_require__(4);
var checkPropTypes = __webpack_require__(6);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(0);
var ReactPropTypesSecret = __webpack_require__(4);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _blank = __webpack_require__(15);

Object.defineProperty(exports, 'blank', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blank).default;
  }
});

var _loadingBalls = __webpack_require__(16);

Object.defineProperty(exports, 'balls', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingBalls).default;
  }
});

var _loadingBars = __webpack_require__(17);

Object.defineProperty(exports, 'bars', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingBars).default;
  }
});

var _loadingBubbles = __webpack_require__(18);

Object.defineProperty(exports, 'bubbles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingBubbles).default;
  }
});

var _loadingCubes = __webpack_require__(19);

Object.defineProperty(exports, 'cubes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingCubes).default;
  }
});

var _loadingCylon = __webpack_require__(20);

Object.defineProperty(exports, 'cylon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingCylon).default;
  }
});

var _loadingSpin = __webpack_require__(21);

Object.defineProperty(exports, 'spin', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingSpin).default;
  }
});

var _loadingSpinningBubbles = __webpack_require__(22);

Object.defineProperty(exports, 'spinningBubbles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingSpinningBubbles).default;
  }
});

var _loadingSpokes = __webpack_require__(23);

Object.defineProperty(exports, 'spokes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loadingSpokes).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"icon-blank\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"></svg>\n";

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"icon-loading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(-8 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"-8 0; 2 0; 2 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.25;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(2 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"2 0; 12 0; 12 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.35;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(12 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"12 0; 22 0; 22 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.45;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(24 0)\" d=\"M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"22 0; 32 0; 32 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.55;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n</svg>\n";

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(2)\" d=\"M0 12 V20 H4 V12z\"> \n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(8)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.2\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(14)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.4\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path transform=\"translate(20)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.6\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path transform=\"translate(26)\" d=\"M0 12 V20 H4 V12z\">\n    <animate attributeName=\"d\" values=\"M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.8\" keytimes=\"0;.2;.5;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n</svg>\n";

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <circle transform=\"translate(8 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"translate(16 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.3\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"translate(24 0)\" cx=\"0\" cy=\"16\" r=\"0\"> \n    <animate attributeName=\"r\" values=\"0; 4; 0; 0\" dur=\"1.2s\" repeatCount=\"indefinite\" begin=\"0.6\"\n      keytimes=\"0;0.2;0.7;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n</svg>\n";

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(-8 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"-8 0; 2 0; 2 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.25;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(2 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"2 0; 12 0; 12 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.35;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(12 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"12 0; 22 0; 22 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.45;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n  <path transform=\"translate(24 0)\" d=\"M0 12 V20 H8 V12z\"> \n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"22 0; 32 0; 32 0;\" dur=\"0.8s\" repeatCount=\"indefinite\" begin=\"0\" keytimes=\"0;.55;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8\" calcMode=\"spline\"  />\n  </path>\n</svg>\n";

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path opacity=\"0.5\" transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0.1s\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n  <path opacity=\"0.25\" transform=\"translate(0 0)\" d=\"M0 12 V20 H4 V12z\">\n    <animateTransform attributeName=\"transform\" type=\"translate\" values=\"0 0; 28 0; 0 0; 0 0\" dur=\"1.5s\" begin=\"0.2s\" repeatCount=\"indefinite\" keytimes=\"0;0.3;0.6;1\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </path>\n</svg>\n";

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path opacity=\".25\" d=\"M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4\"/>\n  <path d=\"M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z\">\n    <animateTransform attributeName=\"transform\" type=\"rotate\" from=\"0 16 16\" to=\"360 16 16\" dur=\"0.8s\" repeatCount=\"indefinite\" />\n  </path>\n</svg>\n";

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <circle cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(45 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.125s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(90 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.25s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(135 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.375s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(180 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(225 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.625s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(270 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.75s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(315 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.875s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n  <circle transform=\"rotate(180 16 16)\" cx=\"16\" cy=\"3\" r=\"0\">\n    <animate attributeName=\"r\" values=\"0;3;0;0\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\" keySplines=\"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8\" calcMode=\"spline\" />\n  </circle>\n</svg>\n";

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "<svg id=\"loading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(0 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(45 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.125s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(90 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.25s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(135 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.375s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(180 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.5s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(225 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.675s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(270 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.75s\"/>\n  </path>\n  <path opacity=\".1\" d=\"M14 0 H18 V8 H14 z\" transform=\"rotate(315 16 16)\">\n    <animate attributeName=\"opacity\" from=\"1\" to=\".1\" dur=\"1s\" repeatCount=\"indefinite\" begin=\"0.875s\"/>\n  </path>\n</svg>\n";

/***/ })
/******/ ]);
});

});

var ReactLoading = unwrapExports(reactLoading);

const styles$2 = theme => ({
  root: {
    padding: theme.spacing(2)
  },
  textField: {//    width: '100%'
  }
});

const FormInput = ({
  classes,
  theme,
  formFields,
  saveForm,
  initial = {}
}) => {
  if (!initial || initial === undefined) initial = {};
  const [formValues, setFormValues] = useState(initial);
  const [errorTexts, setErrorTexts] = useState({});

  const isValid = (val, required = true, type = null) => {
    if (!val || val == undefined) val = "";else val = val.trim();
    if (required && val.length == 0) return false;
    if (val.length > 0) if (type == 'email') {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(val).toLowerCase())) return false;
    }
    return true;
  };

  const validateAndSave = () => {
    let errors = {};
    formFields.forEach(ff => {
      if (!isValid(formValues[ff.field_name], true)) errors[ff.field_name] = "Invalid";
    });

    if (Object.keys(errors).length > 0) {
      setErrorTexts(errors);
      alert("Please check some invalid input.");
    } else saveForm(formValues);
  };

  const onValueChanged = name => event => {
    setFormValues({ ...formValues,
      [name]: event.target.value
    });
  };

  let controls = formFields.map(ff => {
    if (ff.input_type == 'text') {
      return React.createElement(TextField, {
        label: ff.label,
        value: formValues[ff.field_name],
        error: 'first_name' in errorTexts ? true : false,
        onChange: onValueChanged(ff.field_name),
        className: classes.textField,
        margin: "normal",
        fullWidth: true
      });
    } else if (ff.input_type == 'radio') {
      return React.createElement(FormControl, {
        component: "fieldset"
      }, React.createElement(FormLabel, {
        component: "legend"
      }, ff.label), React.createElement(RadioGroup, {
        name: ff.field_name,
        value: formValues[ff.field_name],
        onChange: onValueChanged(ff.field_name),
        row: true
      }, ff.options.map(o => React.createElement(FormControlLabel, {
        control: React.createElement(Radio, {
          color: "primary"
        }),
        value: o.value,
        label: o.text
      }))));
    }
  });
  return React.createElement(Paper, {
    className: classes.root
  }, controls, React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: validateAndSave
  }, "Submit"));
};

var FormInput$1 = withStyles(styles$2, {
  withTheme: true
})(FormInput);

const styles$3 = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper
  },
  header: {
    zIndex: 1300,
    position: 'sticky',
    top: '0'
  },
  footer: {
    display: 'block',
    position: 'sticky',
    bottom: '0'
  },
  chatHeader: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing.unit * 2
  },
  chatHeaderContent: {
    paddingLeft: theme.spacing.unit * 6,
    paddingBottom: theme.spacing.unit * 2
  },
  avatar: {
    width: 50,
    height: 50,
    backgroundColor: '#ddd'
  },
  headerTitle: {
    fontWeight: 800
  },
  headerSubTitle: {},
  chatInfo: {
    color: '#999'
  },
  messageTop: {
    //    minHeight: '70vh',
    //    [theme.breakpoints.up('sm')]: {
    //      minHeight: '80vh'
    //    }
    minHeight: '50vh',
    [theme.breakpoints.up('sm')]: {
      //      minHeight: '30vh'
      minHeight: '40vh'
    }
  },
  messageList: {
    width: '100%',
    //    maxWidth: 500,
    padding: theme.spacing.unit * 2,
    backgroundColor: '#eee'
  },
  inline: {
    display: 'inline'
  },
  componentBar: {
    margin: 0
  },
  composeBar: {
    //    marginTop: theme.spacing.unit * 2,
    //    marginBottom: theme.spacing.unit * 2,
    display: 'block' //    position: 'fixed',
    //    bottom: 0

  },
  composeBarPaper: {
    display: 'flex',
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    margin: 'auto',
    //    maxWidth: 500,
    alignItems: 'center'
  },
  filesPreviewPaper: {
    display: 'flex',
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  composeInput: {
    //    padding: `${theme.spacing.unit * 2}`,
    paddingLeft: theme.spacing.unit * 1,
    paddingRight: 0,
    //theme.spacing.unit * 1.5,
    paddingTop: theme.spacing.unit * 0,
    paddingBottom: theme.spacing.unit * 0,
    width: '100%'
  },
  composeIcon: {
    padding: theme.spacing.unit
  },
  composeSendIcon: {
    padding: theme.spacing.unit
  },
  displayNone: {
    display: 'none'
  },
  attachFileZone: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    marginBottom: theme.spacing.unit
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  previewImageDiv: {
    width: '100%',
    borderColor: '#eeeeee',
    borderWidth: 1
  },
  muted: {
    color: '#999'
  },
  sliderPrevButton: {
    top: '50%',
    display: 'block',
    position: 'absolute',
    transform: 'translate(0, -50%)',
    left: 0,
    zIndex: 1,
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '50%'
  },
  sliderNextButton: {
    top: '50%',
    display: 'block',
    position: 'absolute',
    transform: 'translate(0, -50%)',
    right: 0,
    zIndex: 1,
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '50%'
  },
  iconChevron: {
    fontSize: '2rem',
    color: 'white'
  }
});

const FilePreview = ({
  classes,
  file
}) => {
  const [image, setImage] = useState(null);
  useEffect(() => {
    let reader = new FileReader();

    reader.onload = e => {
      setImage(e.target.result);
    };

    reader.readAsDataURL(file);
  }, file);
  return React.createElement("div", {
    className: classes.previewImageDiv
  }, React.createElement("img", {
    src: image,
    className: classes.previewImage
  }));
};
/*
const AttachFileZone = ({ classes, onCancel, sendFiles }) => {
  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files
  }, [])
  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({onDrop})
  
  const [ files, setFiles ] = useState([])
  
  useEffect(() => {
    if (acceptedFiles)
      setFiles([...files, ...acceptedFiles])
  }, [acceptedFiles])
  
  return (
    <div>
      <div {...getRootProps()} className={ classes.attachFileZone }>
        <input {...getInputProps()} />
        { isDragActive ?
          <p>Drop the files here ...</p>
          :
          <Grid container spacing={1}>
            { files.map(file => (
              <Grid item xs={3}>              
                <FilePreview classes={classes} file={file} />
              </Grid>
              ))
            }
            <Grid item xs={3}>              
              <p>Add file</p>
            </Grid>
          </Grid>          
        }
      </div>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Button variant="contained" color="primary" size="medium" aria-label="" className={classes.mainButton} fullWidth onClick={()=>sendFiles(files)}>
            Kirim
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button variant="outlined" color="secondary" size="medium" aria-label="" className={classes.mainButton} fullWidth onClick={onCancel}>
            Batal
          </Button>
        </Grid>
      </Grid>
      
    </div>
  )
}
*/


const ComposeBar = ({
  classes,
  sendMessage,
  defaultValue
}) => {
  const [message, setMessage] = useState({
    body: ""
  });
  const [files, setFiles] = useState([]);

  const handleChange = name => event => {
    setMessage({ ...message,
      [name]: event.target.value
    });
  };

  const handleKeyDown = event => {
    if (event.keyCode == 13) send();
  };

  const send = () => {
    sendMessage(message.body, files);
    clear();
  };

  const clear = () => {
    setMessage({ ...message,
      body: ""
    });
    setFiles([]);
  };

  useEffect(() => {
    if (defaultValue) setMessage({ ...message,
      body: defaultValue
    });
  }, [defaultValue]);

  const addFiles = ({
    target
  }) => {
    let newFiles = [];

    for (let i = 0; i < target.files.length; i++) {
      let file = target.files[i];
      newFiles.push(file);
    }

    setFiles([...files, ...newFiles]);
  };

  return React.createElement(Box, {
    className: classes.composeBar
  }, files.length ? React.createElement(Paper, {
    className: classes.filesPreviewPaper,
    elevation: 0
  }, React.createElement(Grid, {
    container: true,
    spacing: 1
  }, files.map(file => React.createElement(Grid, {
    item: true,
    xs: 3
  }, React.createElement(FilePreview, {
    classes: classes,
    file: file
  }))))) : React.createElement(React.Fragment, null), React.createElement(Paper, {
    className: classes.composeBarPaper,
    elevation: 0
  }, React.createElement(Input, {
    placeholder: "Tulis pesan anda",
    className: classes.composeInput,
    margin: "normal",
    variant: "filled",
    disableUnderline: true,
    value: message.body,
    onChange: handleChange("body"),
    onKeyDown: handleKeyDown
  }), React.createElement("input", {
    accept: "image/*",
    className: classes.input,
    style: {
      display: 'none'
    },
    id: "raised-button-file",
    multiple: true,
    onChange: addFiles,
    type: "file"
  }), React.createElement("label", {
    htmlFor: "raised-button-file"
  }, React.createElement(IconButton, {
    size: "medium",
    className: classes.composeSendIcon
  }, React.createElement(AddAPhotoIcon, null))), React.createElement(IconButton, {
    size: "medium",
    className: classNames(classes.composeSendIcon, {
      [classes.displayNone]: !message.body && !(files && files.length)
    }),
    onClick: () => send()
  }, React.createElement(SendIcon, null))));
};

const OptionInputBar = ({
  theme,
  classes,
  sendMessage,
  helperText,
  options
}) => {
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  return React.createElement(Box, {
    className: classes.composeBar
  }, React.createElement(Paper, {
    className: classes.composeBarPaper,
    elevation: 0
  }, smUp ? React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    width: "100%",
    flexWrap: "wrap",
    ml: 1,
    mr: 1
  }, React.createElement(Box, {
    mb: 1,
    width: "100%"
  }, React.createElement(Typography, {
    variant: "body2",
    className: classes.muted
  }, helperText)), options.map(option => React.createElement(Box, {
    mt: 1,
    mr: 1
  }, React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    style: {
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize
    },
    onClick: () => sendMessage(JSON.stringify({
      value: option.value,
      text: option.text
    }))
  }, option.text)))) : React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    ml: 1,
    mr: 1
  }, React.createElement(Box, {
    mb: 1
  }, React.createElement(Typography, {
    variant: "body2",
    className: classes.muted
  }, helperText)), options.map(option => React.createElement(Box, {
    mt: 1,
    flexGrow: 1,
    width: "100%"
  }, React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    style: {
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize
    },
    onClick: () => sendMessage(JSON.stringify({
      value: option.value,
      text: option.text
    }))
  }, option.text))))));
};

const InlineOptionInputBar = ({
  theme,
  classes,
  sendMessage,
  helperText,
  options,
  animated
}) => {
  let smUp = useMediaQuery(theme.breakpoints.up('sm'));
  return React.createElement(Box, {
    mt: 1,
    ml: 3
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    flexWrap: "wrap",
    ml: 1,
    mr: 1
  }, options.map(option => React.createElement(Box, {
    mt: 1,
    mr: 1
  }, React.createElement(Reveal, {
    duration: animated ? 500 : 0
  }, React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    style: {
      textTransform: 'none',
      fontSize: theme.typography.body1.fontSize,
      backgroundColor: 'white'
    },
    onClick: () => sendMessage(JSON.stringify({
      value: option.value,
      text: option.text
    }))
  }, option.text))))));
};

const FormInputBar = props => {
  return React.createElement(Box, {
    mt: 1,
    ml: 3
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    flexWrap: "wrap",
    ml: 1,
    mr: 1
  }, React.createElement(FormInput$1, props)));
};

const ChatHeader$1 = ({
  classes,
  business,
  conversation,
  openChat,
  wsState
}) => {
  const navigationContext = useContext(NavigationContext); // When displayed inside popup, we need to get popup width, so that
  // the header div can have fixed position and width.
  // On mobile, we can just use 100%, but not popup is not full width.

  let headerWidth = '100%';
  if ('popupContentWidth' in navigationContext && navigationContext['popupContentWidth'] > 0) headerWidth = navigationContext['popupContentWidth'];
  let headerStyle = {
    //    display: 'block',
    //    position: 'fixed',
    //    top: '0'
    width: headerWidth
  };
  let title = business.name;
  title = conversation.data.parties.map(p => {
    if (p.agent) {
      let name = p.agent.first_name;
      if (p.agent.last_name && p.agent.last_name !== undefined) name += " " + p.agent.last_name;
      if (p.agent.is_service_user) name += ""; //" (Bot)"
      else name += " (Agent)"; //          name += " (" + business.name + ")"

      return name;
    } else return null;
  }).reduce((p, n) => {
    if (p && n) return p + ", " + n;else if (n) return n;else return p;
  });
  if (!title && conversation.data.queue) title = conversation.data.queue.name;
  if (!title || title.length <= 0) title = "You";
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

  const hideMenu = () => {
    setMenuAnchorEl(null);
  };

  return React.createElement("div", {
    className: classes.chatHeader,
    style: headerStyle
  }, React.createElement(Box, {
    container: true,
    className: classes.chatHeaderContent,
    display: "flex",
    direction: "row"
  }, React.createElement(Box, {
    mr: 1
  }, React.createElement(Avatar, {
    src: business.avatar == undefined ? null : business.avatar.image_url,
    className: classes.avatar,
    border: 1
  })), React.createElement(Box, {
    flexGrow: 1
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, React.createElement(Typography, {
    className: classes.headerTitle,
    variant: "body1",
    align: "left"
  }, business.name), false ), React.createElement(Typography, {
    className: classes.headerSubTitle,
    variant: "body2",
    align: "left"
  }, title))), React.createElement(Divider, null), React.createElement(Menu, {
    id: menuAnchorEl ? 'chat-menu-popover' : undefined,
    open: Boolean(menuAnchorEl),
    anchorEl: menuAnchorEl,
    onClose: hideMenu,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, React.createElement(MenuItem, {
    onClick: () => openChat(0)
  }, React.createElement(AddIcon, null), React.createElement(Box, {
    mr: 1
  }), "Start New Chat")), wsState != WSSTATE.Connected && React.createElement(Box, {
    style: {
      position: 'absolute',
      top: '0',
      width: headerWidth,
      textAlign: 'center'
    }
  }, React.createElement(Typography, {
    style: {
      fontSize: '.9em',
      backgroundColor: '#f00',
      color: '#fff'
    }
  }, wsState)));
};

const MessageItem = ({
  classes,
  theme,
  item,
  showResponseTemplate = false,
  openLink,
  sendMessage,
  businessAvatar
}) => {
  let sender = "You";
  let messages = [];
  let date = "";
  let side = "right";
  let avatar = null;

  if (!item.isSending && item.data.sender.agent) {
    sender = item.data.sender.agent.first_name;
    side = "left";
    if (businessAvatar) avatar = businessAvatar;
  }

  let animated = item.data.is_new ? true : false;

  const onCardButtonClick = item => button => {
    if (button.button_type && button.button_type == 'callback') {
      let data = { ...button
      }; // alert(JSON.stringify(data, null, 2))

      sendMessage(JSON.stringify(data));
    } else if (button.link_to) openLink(button.link_to);
  };

  let actionComponent = null;
  let cardComponents = null;

  if (item.data.body && item.data.body != undefined) {
    let body = item.data.body;

    if (body.startsWith("{") && body.endsWith("}")) {
      let data = JSON.parse(body);
      body = data['text'];
      let cardData = data['card'];

      if (cardData) {
        cardComponents = [React.createElement(CardContent, {
          title: cardData['title'],
          subtitle: cardData['subtitle'],
          images: cardData['images'],
          buttons: cardData['buttons'],
          onClick: onCardButtonClick()
        })];
      }

      let cardListData = data['card_list'];

      if (cardListData) {
        cardComponents = cardListData.map(item => React.createElement(CardContent, {
          title: item['title'],
          subtitle: item['subtitle'],
          images: item['images'],
          buttons: item['buttons'],
          onClick: onCardButtonClick()
        }));
      }

      if (showResponseTemplate) {
        let inputType = data['input_type'];

        if (inputType == 'option') {
          actionComponent = React.createElement(InlineOptionInputBar, {
            theme: theme,
            classes: classes,
            options: data['options'],
            helperText: data['helper_text'],
            sendMessage: sendMessage,
            animated: animated
          });
        } else if (inputType == 'form') {
          actionComponent = React.createElement(FormInputBar, {
            formFields: data['form_fields'],
            saveForm: values => {
              sendMessage(JSON.stringify({
                form_values: values,
                text: "Form Data"
              }));
            }
          });
        }
      }
    }

    const renderers = {
      paragraph: props => React.createElement(Typography, {
        gutterBottom: true,
        className: classes.paragraph,
        variant: "body1"
      }, " ", props.children, " ")
    };
    messages.push(React.createElement(ReactMarkdown, {
      source: body,
      renderers: renderers
    })); //    alert(renderToString(<ReactMarkdown source={body} renderers={renderers}/>))
    //    let body = item.data.body.replace(/(\[.*?\]\()(.+?)(\))/g, "<a href='$2'>$1</a>")
    //    messages.push(<>{ body }</>)
  }

  if (item.data.attachments && item.data.attachments !== undefined && item.data.attachments.length > 0) {
    messages.push(...item.data.attachments.map(att => React.createElement("img", {
      src: att.image_url,
      className: classes.previewImage
    })));
  }

  if (item.isSending) date = "Sending...";else if (item.data.sent_at) {
    date = moment(item.data.sent_at).fromNow(true);

    if (item.data.sender && item.data.sender.contact) {
      if (item.data.read_at !== undefined && item.data.read_at) date += " . read";else date += " . not read";
    }
  }

  function SliderPrevArrow(props) {
    const {
      className,
      style,
      onClick
    } = props;
    return React.createElement(Box, {
      className: classes.sliderPrevButton,
      onClick: onClick
    }, React.createElement(ChevronLeftIcon, {
      className: classes.iconChevron
    }));
  }

  function SliderNextArrow(props) {
    const {
      className,
      style,
      onClick
    } = props;
    return React.createElement(Box, {
      className: classes.sliderNextButton,
      onClick: onClick
    }, React.createElement(ChevronRightIcon, {
      className: classes.iconChevron
    }));
  }

  return React.createElement(React.Fragment, null, React.createElement(ChatMessage, {
    side: side,
    avatar: avatar,
    messages: messages,
    status: date,
    animated: animated
  }), cardComponents && false && React.createElement(Box, {
    mt: 2,
    mb: 2
  }, React.createElement(CarouselProvider, {
    naturalSlideWidth: 100,
    naturalSlideHeight: 125,
    totalSlides: cardComponents.length
  }, React.createElement(Slider, null, cardComponents.map((card, index) => React.createElement(Slide, {
    index: index
  }, card))), React.createElement(ButtonNext, {
    className: classes.chevronNext
  }, React.createElement(ChevronRightIcon, {
    className: classes.iconChevron
  })), React.createElement(Box, {
    className: classes.chevronPrev
  }, React.createElement(ButtonBack, null, React.createElement(ChevronLeftIcon, {
    className: classes.iconChevron
  }))))), cardComponents && false && React.createElement(Box, {
    mt: 2,
    mb: 2
  }, React.createElement(Carousel, {
    itemWidth: 240,
    centered: true,
    arrowLeft: React.createElement(Box, {
      className: classes.chevronPrev
    }, React.createElement(ChevronLeftIcon, {
      className: classes.iconChevron
    })),
    arrowRight: React.createElement(Box, {
      className: classes.chevronNext
    }, React.createElement(ChevronRightIcon, {
      className: classes.iconChevron
    })),
    addArrowClickHandler: true
  }, cardComponents.map((card, index) => React.createElement("div", {
    style: {
      margin: 8
    }
  }, card)))), cardComponents && true && React.createElement(Box, {
    mt: 2,
    mb: 2
  }, React.createElement(SlickSlider, {
    className: "center",
    arrows: true,
    slidesToShow: 1.3,
    infinite: false,
    prevArrow: React.createElement(SliderPrevArrow, null),
    nextArrow: React.createElement(SliderNextArrow, null)
  }, cardComponents.map((card, index) => React.createElement("div", null, React.createElement(Box, {
    style: {
      padding: '0px 8px'
    }
  }, card))))), actionComponent && React.createElement(React.Fragment, null, actionComponent));
};

const MessageList = ({
  classes,
  theme,
  business,
  messages,
  parties,
  initialMessage,
  openLink,
  sendMessage
}) => {
  const bottomDiv = useRef(); //  const listDiv = useRef()

  const scrollToBottom = () => {
    //    alert("Scroll to bottom")
    //		listDiv.current.scrollTop = listDiv.current.scrollHeight;
    bottomDiv.current.scrollIntoView({
      behavior: "smooth"
    });
  }; // Scroll to bottom when message is added or typing parties changed


  let messagesLength = messages.length + (parties.filter(item => item['typing_at'] ? true : false).length << 8);
  useEffect(() => {
    scrollToBottom();
  }, [messagesLength]);
  let businessAvatar = business.avatar == undefined ? null : business.avatar.image_url;
  return React.createElement("div", {
    className: classes.messageList
  }, React.createElement("div", {
    className: classes.messageTop
  }), React.createElement(Typography, {
    variant: "body1",
    className: classes.chatInfo,
    gutterBottom: true
  }, initialMessage), messages.length > 0 && messages.map((item, index) => React.createElement(MessageItem, {
    classes: classes,
    theme: theme,
    item: item,
    showResponseTemplate: index == messages.length - 1 ? true : false,
    sendMessage: sendMessage,
    openLink: openLink,
    businessAvatar: businessAvatar
  })), parties.map(item => item['typing_at'] ? React.createElement(ChatMessage, {
    side: "left",
    avatar: businessAvatar,
    messages: [React.createElement(Box, {
      style: {
        height: 32,
        position: 'relative',
        top: -16
      }
    }, React.createElement(ReactLoading, {
      type: "bubbles",
      color: "#555",
      width: 64,
      height: 64
    }))]
  }) : React.createElement(React.Fragment, null)), React.createElement("div", {
    ref: bottomDiv
  }));
};

const ChatMessagesView = ({
  theme,
  classes,
  history,
  business,
  user,
  conversationKey,
  conversation,
  fetchMessages,
  sendMessage,
  markReadAll,
  deleteConversationIfEmpty,
  fetchContactInfo,
  updateContactInfo,
  openChat,
  onHide,
  wsState
}) => {
  const navigationContext = useContext(NavigationContext);
  useEffect(() => {
    //    const intervalID = setInterval(() => {
    //      fetchConversation()
    //      }, 2000)
    return () => {
      //      navigationContext.showTitleBar(null)
      //      clearInterval(intervalID)
      // Delete conversation if it's empty.
      deleteConversationIfEmpty();
    };
  }, []);
  useEffect(() => {
    let timeoutID = null;

    if (conversation.data.new_count > 0) {
      timeoutID = setTimeout(() => {
        markReadAll();
      }, 50);
    }

    return () => {
      if (timeoutID) clearTimeout(timeoutID);
    };
  }, [conversation.data.new_count]);
  const [firstFetch, setFirstFetch] = useState(true);
  /*
  useEffect(() => {
    let timeoutID = null
    if (!conversation.isFetching) {
      if (firstFetch) {
        setFirstFetch(false)
  //        alert("fetchMessages")
        fetchMessages()
        return
      }      
    }
    
    return () => {
      if (timeoutID)
        clearTimeout(timeoutID)
    }
  
  }, [conversation.isFetching])
  */

  useEffect(() => {
    // Refetch on first open or when connected
    if (wsState == WSSTATE.Connected) fetchMessages();
  }, [wsState]);

  const checkOnlineAndSendMessage = (message, files = null) => {
    if (wsState != WSSTATE.Connected) {
      alert("Can not send message because you are not online. Please check your internet connection and try again!");
      return;
    }

    sendMessage(message, files);
  };

  const openLink = linkTo => {
    if (linkTo.startsWith("mailto:")) {
      window.location.href = linkTo;
      return;
    }

    let link = "";
    if (linkTo.startsWith("/")) link = linkTo;else link = "/" + linkTo;
    if (link == "/home") link = "/";
    history.push(link);
    onHide();
  }; // Check last message


  let component = null;
  let defaultValue = null;

  if (conversation.data.accept_reply) {
    if (conversation.messages.length) {
      let lastMessage = conversation.messages[conversation.messages.length - 1];
      let body = lastMessage.data.body;

      if (body.startsWith("{") && body.endsWith("}")) {
        let data = JSON.parse(body);
        let inputType = data['input_type'];
        if ('default' in data) defaultValue = data['default'];

        if (inputType == 'option') {
          component = React.createElement(OptionInputBar, {
            theme: theme,
            classes: classes,
            options: data['options'],
            helperText: data['helper_text'],
            sendMessage: checkOnlineAndSendMessage
          }); // Moved to message list

          component = null;
        }
      }
    }

    if (!component) component = React.createElement(ComposeBar, {
      theme: theme,
      classes: classes,
      sendMessage: checkOnlineAndSendMessage,
      defaultValue: defaultValue
    });
  }

  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: classes.header
  }, React.createElement(ChatHeader$1, {
    classes: classes,
    business: business,
    conversation: conversation,
    openChat: openChat,
    wsState: wsState
  })), React.createElement(MessageList, {
    classes: classes,
    theme: theme,
    business: business,
    messages: conversation.messages,
    parties: conversation.data.parties,
    sendMessage: checkOnlineAndSendMessage,
    openLink: openLink
  }), React.createElement(Divider, null), React.createElement("div", {
    className: classes.footer
  }, component));
};

const NewChatView = ({
  classes,
  business,
  openChat,
  isStarting,
  conversationKey,
  conversation,
  startNewConversation,
  wsStart,
  wsState
}) => {
  const navigationContext = useContext(NavigationContext);
  const [hasStarted, setHasStarted] = React.useState(false); // Initialize new conversation.    

  useEffect(() => {
    if (conversationKey == 0) {
      if (conversation && hasStarted) {
        // Send start command to websocket
        wsStart(); // Reopen chat with new conversation key

        openChat(conversation.key);
      } else {
        // Try to start a new convrsation
        startNewConversation();
        setHasStarted(true);
      }
    } else if (conversationKey == -1) {
      if (conversation) openChat(conversation.key);else openChat(0);
    }
  }, [conversation, conversationKey]);
  return React.createElement("div", {
    className: classes.root,
    style: {
      minHeight: 100
    }
  }, React.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItem: "center"
  }, isStarting ? React.createElement(Typography, {
    variant: "body1"
  }, "Starting...") : React.createElement(Typography, {
    variant: "body1"
  }, "Please wait...")));
};

const ChatView = props => {
  const {
    conversationKey
  } = props;
  if (conversationKey <= 0) return React.createElement(NewChatView, props);else return React.createElement(ChatMessagesView, props);
};

function conversationKeyFromProps(props) {
  let key = 0;
  if (props.conversationKey) key = props.conversationKey;else if (props.match) key = props.match.params.key;
  return key;
}

const mapStateToProps$1 = (state, ownProps) => {
  let key = conversationKeyFromProps(ownProps);
  let c = null;
  let isStarting = false;

  if (key == 0) {
    c = getNewConversation(state);
    isStarting = state.alpha.conversationList.isStarting;
  } else if (key == -1) {
    c = getLatestConversation(state);

    if (!c) {
      c = getNewConversation(state);
      isStarting = state.alpha.conversationList.isStarting;
    }
  } else c = getConversation(state, key);

  return {
    conversationKey: key,
    conversation: c,
    iStarting: isStarting,
    business: getBusinessInfo(state, '0').data,
    user: getUser(state),
    wsState: state.alpha.conversationList.wsState
  };
};

const mapDispatchToProps$1 = (dispatch, ownProps) => {
  let key = conversationKeyFromProps(ownProps);
  return {
    startNewConversation: () => {
      dispatch(startNewConversation());
    },
    deleteConversationIfEmpty: () => {
      dispatch(deleteConversationIfEmpty(key));
    },
    wsStart: () => {
      dispatch(wsSend('start', null));
    },
    fetchMessages: () => {
      dispatch(fetchMessages(key, true, false));
    },
    sendMessage: (message, files = null) => {
      dispatch(sendMessage(key, message, files));
    },
    markReadAll: () => {
      dispatch(markReadAll(key));
    },
    fetchContactInfo: () => {
      dispatch(fetchContactInfo());
    },
    updateContactInfo: data => {
      dispatch(updateContactInfo(data));
    }
  };
};

var Chat = withStyles(styles$3, {
  withTheme: true
})(connect(mapStateToProps$1, mapDispatchToProps$1)(ChatView));

const styles$4 = theme => ({
  root: {},
  floatingChatButton: {
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2)
  },
  windowFrame: {
    /*
    '&::after':{
      bottom: '85px',
      right: '20px',
      width: 0,
      height: 0,
      content: "''",
      borderTop: 'solid 20px white',
      borderLeft: 'solid 25px transparent',
      marginLeft: '0px',
      position: 'fixed',
      borderRight: 'solid 25px transparent',
    },
    */
    zIndex: '1000',
    position: 'fixed',
    bottom: '100px',
    right: '20px',
    width: '400px',
    minHeight: '250px',
    maxHeight: '704px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 5px 40px',
    opacity: 1,
    height: 'calc(100% - 120px)',
    borderRadius: '8px',
    overflowX: 'hidden',
    background: 'white',
    [theme.breakpoints.down('xs')]: {
      // paddingTop: theme.spacing(5),
      zIndex: '1000',
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      height: '100%',
      borderRadius: '0px',
      // overflowY: 'auto',
      background: 'white'
    }
  },
  headerChat: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  labelChat: {
    paddingLeft: theme.spacing(2)
  },
  header: {
    zIndex: 1301,
    position: 'sticky',
    top: '0'
  },
  iconClose: {
    display: 'block',
    position: 'absolute',
    right: '16px',
    top: '26px',
    color: '#aaa'
  },
  iconBack: {
    display: 'block',
    position: 'absolute',
    left: '16px',
    top: '26px',
    color: '#aaa'
  },
  noDecoration: {
    textDecoration: 'none'
  }
});

const ChatWindow = ({
  theme,
  classes,
  history,
  business,
  wsState,
  activeConversationKey,
  setActiveConversation,
  fetchConversationList,
  isFetching,
  lastFetched,
  conversations,
  isOpen,
  onShow,
  onHide
}) => {
  const [conversationKey, setConversationKey] = useState(-1);
  const topDiv = useRef(); // This will be called on component init  

  useEffect(() => {
    fetchConversationList();
    return () => {};
  }, []);
  useEffect(() => {
    if (conversationKey != activeConversationKey) setConversationKey(activeConversationKey);
  }, [activeConversationKey]);
  useEffect(() => {
    if (conversationKey == -1 && topDiv.current) // Scroll to top
      topDiv.current.scrollIntoView({
        behavior: "smooth"
      });
  }, [conversationKey]);
  let sm = useMediaQuery(theme.breakpoints.up('sm'));

  const showConversation = key => {
    if (wsState != WSSTATE.Connected) {
      alert("Can not start chat while you are not online. Please check your internet connection.");
      return;
    }

    if (key != activeConversationKey) setActiveConversation(key);else setConversationKey(key);
  };

  const hideConversation = () => {
    setConversationKey(-1);
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: classes.floatingChatButton
  }, isOpen ? React.createElement(Fab, {
    color: "primary",
    "aria-label": "add",
    onClick: onHide
  }, React.createElement(CloseIcon, null)) : React.createElement(Fab, {
    color: "primary",
    "aria-label": "add",
    onClick: onShow
  }, React.createElement(ForumIcon, null))), isOpen && React.createElement(ClickAwayListener, {
    onClickAway: onHide
  }, React.createElement(Slide$2, {
    direction: "left",
    in: isOpen,
    mountOnEnter: true,
    unmountOnExit: true
  }, React.createElement("div", {
    className: classes.windowFrame
  }, React.createElement("div", {
    className: classes.header
  }, React.createElement("div", {
    className: classes.iconClose,
    onClick: onHide
  }, React.createElement(CloseIcon, {
    style: {
      fontSize: '2rem'
    }
  })), conversationKey >= 0 && React.createElement("div", {
    className: classes.iconBack,
    onClick: hideConversation
  }, React.createElement(ArrowBackIcon, {
    style: {
      fontSize: '2rem'
    }
  }))), React.createElement("div", {
    ref: topDiv
  }), conversationKey >= 0 ? React.createElement(Chat, {
    conversationKey: conversationKey,
    openChat: showConversation,
    closeChat: hideConversation,
    onHide: onHide,
    history: history
  }) : React.createElement(Inbox, {
    openChat: showConversation,
    onHide: onHide
  })))));
};

const mapStateToProps$2 = (state, ownProps) => {
  return { ...state.alpha.conversationList,
    business: getBusinessInfo(state).data
  };
};

const mapDispatchToProps$2 = (dispatch, ownProps) => {
  return {
    fetchConversationList: () => {
      dispatch(fetchConversationList(true));
    },
    setActiveConversation: key => {
      dispatch(setActiveConversation(key));
    }
  };
};

var ChatWindow$1 = withRouter(withStyles(styles$4, {
  withTheme: true
})(connect(mapStateToProps$2, mapDispatchToProps$2)(ChatWindow)));

const styles$5 = theme => ({
  root: {},
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  floatingChat: {
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: 2
  },
  frameChat: {
    '&::after': {
      bottom: '85px',
      right: '20px',
      width: 0,
      height: 0,
      content: "''",
      borderTop: 'solid 20px white',
      borderLeft: 'solid 25px transparent',
      marginLeft: '0px',
      position: 'fixed',
      borderRight: 'solid 25px transparent'
    },
    zIndex: '1000',
    position: 'fixed',
    bottom: '100px',
    right: '20px',
    width: '376px',
    minHeight: '250px',
    maxHeight: '704px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 5px 40px',
    opacity: 1,
    height: 'calc(100% - 120px)',
    borderRadius: '8px',
    overflowX: 'hidden',
    background: 'white',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(5),
      zIndex: '1000',
      position: 'fixed',
      top: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      height: '100%',
      borderRadius: '0px',
      // overflowY: 'auto',
      background: 'white'
    }
  },
  headerChat: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  labelChat: {
    paddingLeft: theme.spacing(2)
  },
  iconClose: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      position: 'fixed',
      right: '10px',
      top: '10px'
    }
  },
  noDecoration: {
    textDecoration: 'none'
  }
});

const AppBase = props => {
  const {
    classes,
    business,
    history,
    user,
    companies,
    visitor,
    wsState,
    params,
    chat
  } = props;
  const {
    fetchBusinessInfo,
    fetchConversationList,
    fetchProductsCount,
    login,
    authenticateWithToken,
    setActiveCompany,
    fetchContactInfo,
    init,
    register
  } = props;
  const [showInbox, setShowInbox] = useState(chat);
  const [showChat, setShowChat] = useState(false);
  const [showClose, setShowClose] = useState(false); //  const [hasFetchProductsCount, setHasFetchProductsCount] = useState(false)

  const getWSHost = () => {
    let host = process.env.REACT_APP_GOAPP_API_URL + "/ws/conversation/";
    host = host.replace("http://", "ws://");
    host = host.replace("https://", "wss://");
    host = host + "?visitor=" + visitor.data.visitor_id;
    if (user.isLoggedIn) host += "&token=" + user.authToken;
    host += "&api_key=" + process.env.REACT_APP_GOAPP_API_KEY;
    return host;
  };

  const [isOnline, setIsOnline] = useState(false);
  useEffect(() => {
    fetchBusinessInfo();
    window.addEventListener('online', e => {
      setIsOnline(true);
    });
    window.addEventListener('offline', e => {
      setIsOnline(false);
    });
    return () => {//      clearInterval(conversationTimerID)
    };
  }, []);
  useEffect(() => {
    //    alert("WebSocket state: " + wsState)
    if (wsState == WSSTATE.Disconnected) {
      let timeout = 250;
      if (!isOnline) timeout = 3000;
      setTimeout(() => {
        //        alert(getWSHost())
        props.wsConnect(getWSHost());
      }, timeout);
    } else if (wsState == WSSTATE.Connected) {
      // Refresh conversation list on re-connect.
      fetchConversationList(true);
    }
  }, [wsState]); // Floating chat state

  const [isChatWindowOpen, setChatWindowOpen] = useState(false);

  const showChatWindow = show => {
    setChatWindowOpen(show);
  };

  useEffect(() => {
    if (!business.lastFetched) // Wait
      return;

    if (params.get('reset') == 1) {
      ls.remove('_goid');
      ls.remove('_userInfo'); // Reload app

      window.open(process.env.REACT_APP_PUBLIC_URL, "_self");
      return;
    } // Check token from callback URL


    let authToken = params.get('auth_token');

    if (authToken && !user.isLoggedIn) {
      let authSuccess = params.get('auth_success');
      authenticateWithToken(authToken);
      params.delete('auth_token');
      params.delete('auth_success'); // Update url
      // Note: Should use history.replace so that path with token not pushed
      // to history, but it doesn't work.

      history.push({
        pathname: history.location.pathname,
        search: params.toString()
      });
    } else if (user.isAuthenticating) ; else if (user.userInfo && !user.isLoggedIn) {
      if (!user.isAuthenticating) // Try to login automatically
        login();
    } else if (!visitor.isInitialized) {
      init();
    } else if (!visitor.isRegistered) {
      let registerData = {};
      if (user.isLoggedIn) registerData = {
        external_app: 'alpha.apps.directory',
        external_model: 'user',
        external_id: user.userInfo.uid,
        first_name: user.userInfo.first_name,
        last_name: user.userInfo.last_name,
        email: user.userInfo.email,
        mobile_no: user.userInfo.mobile_no
      };else registerData = {};
      register(registerData);
    } else if (user.isUpdatingContact) ; else if (!user.lastContactUpdate) {
      // Fetch contact info.
      fetchContactInfo();
    } else {
      /*
      if (!conversationTimerID || conversationTimerID == undefined) {
        // First chat
        fetchConversationList(true)
        
        let conversationTimerID = setInterval(() => {
      //          alert("timer timeout")
          fetchConversationList(true)
          }, 15000)
        setConversationTimerID(conversationTimerID)
      }
      */
      // Connect to conversation ws
      if (wsState == WSSTATE.Idle) {
        props.wsConnect(getWSHost());
      }
      /*
            if (!hasFetchProductsCount) {
              fetchProductsCount()
              setHasFetchProductsCount(true)
            }      
      */


      if (user.isLoggedIn && !user.companyInfo && companies.length > 0) setActiveCompany(companies[0].uid);
    } //    alert(this.props.location)
    //    if (this.props.location !== prevProps.location) {
    //      visitor_log_event('View Page', { 'url': this.props.location })
    //    }

  }); // Show page

  if (business.lastFetched && !user.isAuthenticating && visitor.isRegistered && user.lastContactUpdate) return React.createElement("div", {
    className: classes.root
  }, Array.isArray(props.children) ? React.createElement(React.Fragment, null, props.children.map(c => c)) : React.createElement(React.Fragment, null, props.children), React.createElement(ChatWindow$1, {
    isOpen: isChatWindowOpen,
    onHide: () => showChatWindow(false),
    onShow: () => showChatWindow(true)
  }));else {
    // Show loading messages
    let message = "...";
    if (business.isFetching) message = "Initializing...";else if (user.isAuthenticating) message = "Authenticating...";else if (visitor.isInitializing || visitor.isRegistering) message = "Almost done...";else if (user.isUpdatingContact) message = "One second...";
    return React.createElement("div", {
      className: classes.root
    }, React.createElement("div", {
      className: classes.wrapper
    }, message));
  }
};

const mapStateToProps$3 = (state, ownProps) => {
  let urlParams = new URLSearchParams(ownProps.location.search);
  return {
    user: getUser(state),
    companies: getCompanies(state),
    visitor: state.alpha.visitor,
    business: getBusinessInfo(state, '0'),
    params: urlParams,
    wsState: state.alpha.conversationList.wsState,
    chat: false
  };
};

const mapDispatchToProps$3 = (dispatch, ownProps) => {
  //  let callbackUrl = process.env.REACT_APP_PUBLIC_URL + ownProps.location.path
  let callbackUrl = window.location.href; //  alert(callbackUrl)

  return {
    fetchBusinessInfo: () => {
      dispatch(fetchBusinessInfo('0'));
    },
    login: () => {
      dispatch(login(callbackUrl, true));
    },
    authenticateWithToken: authToken => {
      dispatch(authenticateWithToken(authToken));
    },
    fetchContactInfo: () => {
      dispatch(fetchContactInfo());
    },
    setActiveCompany: companyID => {
      dispatch(setActiveCompany(companyID));
    },
    init: () => {
      dispatch(init());
    },
    register: registerData => {
      dispatch(register(registerData));
    },
    fetchProductsCount: () => {
      dispatch(fetchProductIndex('default', null));
    },
    fetchConversationList: refresh => {
      dispatch(fetchConversationList(refresh));
    },
    wsConnect: host => {
      dispatch(wsConnect(host));
    }
  };
};

const App = withRouter(withStyles(styles$5, {
  withTheme: true
})(connect(mapStateToProps$3, mapDispatchToProps$3)(AppBase)));
const withAppBase = Component => props => {
  return React.createElement(App, null, React.createElement(Component, props));
};

const contentRecordInitial = {
  isFetching: false,
  isPartial: false,
  isError: false,
  lastFetched: null,
  data: {}
};
const contentIndexInitial = {
  isFetching: false,
  isError: false,
  lastFetched: null,
  data: {
    records: null
  }
}; // Actions

const ACTION$4 = {
  requestContentIndex: "requestContentIndex",
  receiveContentIndex: "receiveContentIndex",
  errorRequestContentIndex: "errorRequestContentIndex",
  requestContentRecord: "requestContentRecord",
  receiveContentRecord: "receiveContentRecord",
  errorRequestContentRecord: "errorRequestContentRecord"
}; // Async action creator

const getContentIndex = (state, modelKey, indexKey = 'default') => {
  if (modelKey in state.alpha.content) {
    if (indexKey in state.alpha.content[modelKey].indexes) return state.alpha.content[modelKey].indexes[indexKey];
  }

  return contentIndexInitial;
};
const fetchContentIndex = (modelKey, indexKey, params = null, refresh = false) => {
  return (dispatch, getState) => {
    let res = getContentIndex(getState(), modelKey, indexKey);
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve();
    if (!indexKey) indexKey = "default";
    let url = process.env.REACT_APP_GOAPP_API_URL + "/content/api/content/?model=" + modelKey;
    let api_key = process.env.REACT_APP_GOAPP_API_KEY;
    if (params) url += Object.keys(params).map(key => "&" + key + "=" + params[key]).join(""); //    alert("Fetching: " + url)

    dispatch(requestContentIndex(modelKey, indexKey, params));
    return fetch(url, {
      headers: {
        'X-API-Key': api_key
      }
    }).then(response => response.json()).then(json => dispatch(receiveContentIndex(modelKey, indexKey, params, json))).catch(error => dispatch(errorRequestContentIndex(modelKey, indexKey, params, error)));
  };
};
const getContentRecord = (state, modelKey, recordKey) => {
  if (modelKey in state.alpha.content) {
    if (recordKey in state.alpha.content[modelKey].records) return state.alpha.content[modelKey].records[recordKey];
  }

  return contentRecordInitial;
};
const fetchContentRecord = (modelKey, recordKey, refresh = false, params = null) => {
  return (dispatch, getState) => {
    let res = getContentRecord(getState(), modelKey, recordKey);
    if (res.isFetching || res.lastFetched && !refresh) return Promise.resolve();
    let url = process.env.REACT_APP_GOAPP_API_URL + "/content/api/content/" + recordKey + "/";
    let api_key = process.env.REACT_APP_GOAPP_API_KEY;
    if (params) url += Object.keys(params).map(key => "&" + key + "=" + params[key]).join("");
    dispatch(requestContentRecord(modelKey, recordKey, params));
    return fetch(url, {
      headers: {
        'X-API-Key': api_key
      }
    }).then(response => response.json()).then(json => dispatch(receiveContentRecord(modelKey, recordKey, params, json))).catch(error => dispatch(errorRequestContentRecord(modelKey, recordKey, params, error)));
  };
}; // Synchronous Action Creators for Content Index

const requestContentIndex = (modelKey, indexKey, params) => ({
  type: ACTION$4.requestContentIndex,
  modelKey,
  indexKey,
  params
});
const receiveContentIndex = (modelKey, indexKey, params, json) => {
  let result = {
    count: json.length,
    records: json
  }; //  alert("receiveContentIndex")
  //  alert(JSON.stringify(result, null, 2))

  return {
    type: ACTION$4.receiveContentIndex,
    modelKey,
    indexKey,
    result: result,
    receivedAt: Date.now()
  };
};
const errorRequestContentIndex = (modelKey, indexKey, params, error) => ({
  type: ACTION$4.errorRequestContentIndex,
  modelKey,
  indexKey,
  params,
  error
});
const requestContentRecord = (modelKey, contentKey, params) => ({
  type: ACTION$4.requestContentRecord,
  modelKey,
  contentKey,
  params
});
const receiveContentRecord = (modelKey, contentKey, params, json) => {
  let result = json; //  alert(JSON.stringify(json, null, 2))

  return {
    type: ACTION$4.receiveContentRecord,
    modelKey,
    contentKey,
    result: result,
    receivedAt: Date.now()
  };
};
const errorRequestContentRecord = (modelKey, contentKey, params, error) => ({
  type: ACTION$4.errorRequestContentRecord,
  modelKey,
  contentKey,
  params,
  error
}); // Reducers for Content Index

const contentIndexReducer = createReducer(contentIndexInitial, {
  [ACTION$4.requestContentIndex]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$4.receiveContentIndex]: (state, action) => {
    return { ...state,
      isFetching: false,
      isPartial: false,
      lastFetched: action.receivedAt,
      data: action.result
    };
  },
  [ACTION$4.errorRequestContentIndex]: (state, action) => {
    alert("Request content index failed: " + action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  }
});

function contentIndexByKeyUpdater(state, action) {
  let key = action.indexKey;
  return { ...state,
    [key]: contentIndexReducer(state[key], action)
  };
}

const contentIndexByKeyReducer = createReducer({}, {
  [ACTION$4.requestContentIndex]: contentIndexByKeyUpdater,
  [ACTION$4.receiveContentIndex]: contentIndexByKeyUpdater,
  [ACTION$4.errorReceiveContentIndex]: contentIndexByKeyUpdater
}); // Reducers for Content Record

const contentRecordReducer = createReducer(contentRecordInitial, {
  [ACTION$4.requestContentRecord]: (state, action) => {
    return { ...state,
      isFetching: true
    };
  },
  [ACTION$4.receiveContentRecord]: (state, action) => {
    return { ...state,
      isFetching: false,
      isPartial: false,
      lastFetched: action.receivedAt,
      data: action.result
    };
  },
  [ACTION$4.errorRequestContentRecord]: (state, action) => {
    alert("Request content record failed: " + action.error);
    return { ...state,
      isFetching: false,
      isError: true
    };
  }
});

function contentRecordByKeyUpdater(state, action) {
  let key = action.contentKey;
  return { ...state,
    [key]: contentRecordReducer(state[key], action)
  };
}

const contentRecordByKeyReducer = createReducer({}, {
  [ACTION$4.requestContentRecord]: contentRecordByKeyUpdater,
  [ACTION$4.receiveContentRecord]: contentRecordByKeyUpdater,
  [ACTION$4.errorRequestContentRecord]: contentRecordByKeyUpdater
}); // Combine all content reducer

const contentReducer = combineReducers({
  indexes: contentIndexByKeyReducer,
  records: contentRecordByKeyReducer
}); // Content model by key reducer

function contentModelReducer(state = {}, action) {
  if (action.type in ACTION$4) {
    let modelKey = action.modelKey;
    let newState = { ...state,
      [modelKey]: contentReducer(state[modelKey], action)
    }; //    alert(JSON.stringify(newState, null, 2))

    return newState;
  }

  return state;
}

const alphaReducer = combineReducers({
  business: businessByIdReducer,
  user: userReducer,
  visitor: visitorReducer,
  content: contentModelReducer,
  conversationList: conversationListReducer
});

export { alphaReducer, conversation as conversationMiddleware, createReducer, fetchBusinessInfo, fetchContactInfo, fetchContentIndex, fetchContentRecord, getBusinessInfo, getCompanies, getContentIndex, getContentRecord, getUser, getVisitor, logEvent, login, logout, register$1 as register, setActiveCompany, updateContactInfo, withAppBase };
//# sourceMappingURL=index.es.js.map
